var _regeneratorRuntime = require("/Users/LexusDrumgold/Documents/projects/fisher1yearlater/node_modules/@babel/runtime/regenerator");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("firebase")) : "function" == typeof define && define.amd ? define("flamelink", ["firebase"], t) : "object" == typeof exports ? exports.flamelink = t(require("firebase")) : e.flamelink = t(e.firebase);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var i = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var i in e) {
        t.d(n, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 100);
  }([function (e, t) {
    var r = Array.isArray;
    e.exports = r;
  }, function (e, t, r) {
    var n = r(55),
        i = "object" == typeof self && self && self.Object === Object && self,
        o = n || i || Function("return this")();
    e.exports = o;
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, r) {
    var n = r(54),
        i = r(57),
        o = r(13);

    e.exports = function (e) {
      return o(e) ? n(e) : i(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t, r) {
    var n = r(7),
        i = r(109),
        o = r(110),
        a = "[object Null]",
        u = "[object Undefined]",
        s = n ? n.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? u : a : s && s in Object(e) ? i(e) : o(e);
    };
  }, function (e, t, r) {
    var n = r(128),
        i = r(131);

    e.exports = function (e, t) {
      var r = i(e, t);
      return n(r) ? r : void 0;
    };
  }, function (e, t, r) {
    var n = r(1).Symbol;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(10),
        i = 1 / 0;

    e.exports = function (e) {
      if ("string" == typeof e || n(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -i ? "-0" : t;
    };
  }, function (e, t, r) {
    var n = r(155),
        i = r(34),
        o = r(156),
        a = r(157),
        u = r(66),
        s = r(5),
        c = r(59),
        f = c(n),
        l = c(i),
        p = c(o),
        d = c(a),
        h = c(u),
        v = s;
    (n && "[object DataView]" != v(new n(new ArrayBuffer(1))) || i && "[object Map]" != v(new i()) || o && "[object Promise]" != v(o.resolve()) || a && "[object Set]" != v(new a()) || u && "[object WeakMap]" != v(new u())) && (v = function v(e) {
      var t = s(e),
          r = "[object Object]" == t ? e.constructor : void 0,
          n = r ? c(r) : "";
      if (n) switch (n) {
        case f:
          return "[object DataView]";

        case l:
          return "[object Map]";

        case p:
          return "[object Promise]";

        case d:
          return "[object Set]";

        case h:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = v;
  }, function (e, t, r) {
    var n = r(5),
        i = r(2),
        o = "[object Symbol]";

    e.exports = function (e) {
      return "symbol" == typeof e || i(e) && n(e) == o;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    var r = 9007199254740991,
        n = /^(?:0|[1-9]\d*)$/;

    e.exports = function (e, t) {
      var i = typeof e;
      return !!(t = null == t ? r : t) && ("number" == i || "symbol" != i && n.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, r) {
    var n = r(31),
        i = r(27);

    e.exports = function (e) {
      return null != e && i(e.length) && !n(e);
    };
  }, function (e, t, r) {
    var n = r(116),
        i = r(159),
        o = r(40),
        a = r(0),
        u = r(164);

    e.exports = function (e) {
      return "function" == typeof e ? e : null == e ? o : "object" == typeof e ? a(e) ? i(e[0], e[1]) : n(e) : u(e);
    };
  }, function (e, t, r) {
    function n(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    var i = r(118),
        o = r(119),
        a = r(120),
        u = r(121),
        s = r(122);
    n.prototype.clear = i, n.prototype.delete = o, n.prototype.get = a, n.prototype.has = u, n.prototype.set = s, e.exports = n;
  }, function (e, t, r) {
    var n = r(33);

    e.exports = function (e, t) {
      for (var r = e.length; r--;) {
        if (n(e[r][0], t)) return r;
      }

      return -1;
    };
  }, function (e, t, r) {
    var n = r(6)(Object, "create");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(140);

    e.exports = function (e, t) {
      var r = e.__data__;
      return n(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
    };
  }, function (e, t, r) {
    var n = r(0),
        i = r(39),
        o = r(70),
        a = r(72);

    e.exports = function (e, t) {
      return n(e) ? e : i(e, t) ? [e] : o(a(e));
    };
  }, function (e, t, r) {
    var n = r(21),
        i = r(4);

    e.exports = function (e) {
      return function () {
        var t = arguments;

        switch (t.length) {
          case 0:
            return new e();

          case 1:
            return new e(t[0]);

          case 2:
            return new e(t[0], t[1]);

          case 3:
            return new e(t[0], t[1], t[2]);

          case 4:
            return new e(t[0], t[1], t[2], t[3]);

          case 5:
            return new e(t[0], t[1], t[2], t[3], t[4]);

          case 6:
            return new e(t[0], t[1], t[2], t[3], t[4], t[5]);

          case 7:
            return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
        }

        var r = n(e.prototype),
            o = e.apply(r, t);
        return i(o) ? o : r;
      };
    };
  }, function (e, t, r) {
    var n = r(4),
        i = Object.create,
        o = function () {
      function e() {}

      return function (t) {
        if (!n(t)) return {};
        if (i) return i(t);
        e.prototype = t;
        var r = new e();
        return e.prototype = void 0, r;
      };
    }();

    e.exports = o;
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = -1,
          n = e.length;

      for (t || (t = Array(n)); ++r < n;) {
        t[r] = e[r];
      }

      return t;
    };
  }, function (e, t, r) {
    var n = r(42),
        i = r(76);

    e.exports = function (e, t, r, o) {
      var a = !r;
      r || (r = {});

      for (var u = -1, s = t.length; ++u < s;) {
        var c = t[u],
            f = o ? o(r[c], e[c], c, r, e) : void 0;
        void 0 === f && (f = e[c]), a ? i(r, c, f) : n(r, c, f);
      }

      return r;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length, i = Array(n); ++r < n;) {
        i[r] = t(e[r], r, e);
      }

      return i;
    };
  }, function (e, t, r) {
    var n = r(107),
        i = r(2),
        o = Object.prototype,
        a = o.hasOwnProperty,
        u = o.propertyIsEnumerable,
        s = n(function () {
      return arguments;
    }()) ? n : function (e) {
      return i(e) && a.call(e, "callee") && !u.call(e, "callee");
    };
    e.exports = s;
  }, function (e, t, r) {
    (function (e) {
      var n = r(1),
          i = r(111),
          o = "object" == typeof t && t && !t.nodeType && t,
          a = o && "object" == typeof e && e && !e.nodeType && e,
          u = a && a.exports === o ? n.Buffer : void 0,
          s = (u ? u.isBuffer : void 0) || i;
      e.exports = s;
    }).call(this, r(11)(e));
  }, function (e, t) {
    var r = 9007199254740991;

    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(55),
          i = "object" == typeof t && t && !t.nodeType && t,
          o = i && "object" == typeof e && e && !e.nodeType && e,
          a = o && o.exports === i && n.process,
          u = function () {
        try {
          return a && a.binding && a.binding("util");
        } catch (e) {}
      }();

      e.exports = u;
    }).call(this, r(11)(e));
  }, function (e, t) {
    var r = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || r);
    };
  }, function (e, t, r) {
    var n = r(5),
        i = r(4),
        o = "[object AsyncFunction]",
        a = "[object Function]",
        u = "[object GeneratorFunction]",
        s = "[object Proxy]";

    e.exports = function (e) {
      if (!i(e)) return !1;
      var t = n(e);
      return t == a || t == u || t == o || t == s;
    };
  }, function (e, t, r) {
    function n(e) {
      var t = this.__data__ = new i(e);
      this.size = t.size;
    }

    var i = r(15),
        o = r(123),
        a = r(124),
        u = r(125),
        s = r(126),
        c = r(127);
    n.prototype.clear = o, n.prototype.delete = a, n.prototype.get = u, n.prototype.has = s, n.prototype.set = c, e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, r) {
    var n = r(6)(r(1), "Map");
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    var i = r(132),
        o = r(139),
        a = r(141),
        u = r(142),
        s = r(143);
    n.prototype.clear = i, n.prototype.delete = o, n.prototype.get = a, n.prototype.has = u, n.prototype.set = s, e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = t.length, i = e.length; ++r < n;) {
        e[i + r] = t[r];
      }

      return e;
    };
  }, function (e, t, r) {
    var n = r(154),
        i = r(65),
        o = Object.prototype.propertyIsEnumerable,
        a = Object.getOwnPropertySymbols,
        u = a ? function (e) {
      return null == e ? [] : (e = Object(e), n(a(e), function (t) {
        return o.call(e, t);
      }));
    } : i;
    e.exports = u;
  }, function (e, t, r) {
    var n = r(19),
        i = r(8);

    e.exports = function (e, t) {
      for (var r = 0, o = (t = n(t, e)).length; null != e && r < o;) {
        e = e[i(t[r++])];
      }

      return r && r == o ? e : void 0;
    };
  }, function (e, t, r) {
    var n = r(0),
        i = r(10),
        o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        a = /^\w*$/;

    e.exports = function (e, t) {
      if (n(e)) return !1;
      var r = typeof e;
      return !("number" != r && "symbol" != r && "boolean" != r && null != e && !i(e)) || a.test(e) || !o.test(e) || null != t && e in Object(t);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, r) {
    var n = r(168);

    e.exports = function (e) {
      var t = n(e),
          r = t % 1;
      return t == t ? r ? t - r : t : 0;
    };
  }, function (e, t, r) {
    var n = r(76),
        i = r(33),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r) {
      var a = e[t];
      o.call(e, t) && i(a, r) && (void 0 !== r || t in e) || n(e, t, r);
    };
  }, function (e, t, r) {
    var n = r(80),
        i = r(176),
        o = r(177),
        a = r(82),
        u = r(195),
        s = r(86),
        c = r(196),
        f = r(88),
        l = r(90),
        p = r(41),
        d = "Expected a function",
        h = 1,
        v = 2,
        g = 8,
        m = 16,
        y = 32,
        b = 64,
        x = Math.max;

    e.exports = function (e, t, r, w, R, _, j, O) {
      var S = t & v;
      if (!S && "function" != typeof e) throw new TypeError(d);
      var k = w ? w.length : 0;

      if (k || (t &= ~(y | b), w = R = void 0), j = void 0 === j ? j : x(p(j), 0), O = void 0 === O ? O : p(O), k -= R ? R.length : 0, t & b) {
        var F = w,
            P = R;
        w = R = void 0;
      }

      var A = S ? void 0 : s(e),
          I = [e, t, r, w, R, F, P, _, j, O];
      if (A && c(I, A), e = I[0], t = I[1], r = I[2], w = I[3], R = I[4], !(O = I[9] = void 0 === I[9] ? S ? 0 : e.length : x(I[9] - k, 0)) && t & (g | m) && (t &= ~(g | m)), t && t != h) E = t == g || t == m ? o(e, t, O) : t != y && t != (h | y) || R.length ? a.apply(void 0, I) : u(e, t, r, w);else var E = i(e, t, r);
      return l((A ? n : f)(E, I), e, t);
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, r[0]);

        case 2:
          return e.call(t, r[0], r[1]);

        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }

      return e.apply(t, r);
    };
  }, function (e, t, r) {
    function n(e) {
      this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = a, this.__views__ = [];
    }

    var i = r(21),
        o = r(46),
        a = 4294967295;
    n.prototype = i(o.prototype), n.prototype.constructor = n, e.exports = n;
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e);) {
        ;
      }

      return e;
    };
  }, function (e, t) {
    var r = "__lodash_placeholder__";

    e.exports = function (e, t) {
      for (var n = -1, i = e.length, o = 0, a = []; ++n < i;) {
        var u = e[n];
        u !== t && u !== r || (e[n] = r, a[o++] = n);
      }

      return a;
    };
  }, function (e, t, r) {
    var n = r(32),
        i = r(47),
        o = r(42),
        a = r(93),
        u = r(198),
        s = r(201),
        c = r(22),
        f = r(202),
        l = r(203),
        p = r(63),
        d = r(204),
        h = r(9),
        v = r(205),
        g = r(206),
        m = r(211),
        y = r(0),
        b = r(26),
        x = r(212),
        w = r(4),
        R = r(214),
        _ = r(3),
        j = 1,
        O = 2,
        S = 4,
        k = "[object Arguments]",
        F = "[object Function]",
        P = "[object GeneratorFunction]",
        A = "[object Object]",
        I = {};

    I[k] = I["[object Array]"] = I["[object ArrayBuffer]"] = I["[object DataView]"] = I["[object Boolean]"] = I["[object Date]"] = I["[object Float32Array]"] = I["[object Float64Array]"] = I["[object Int8Array]"] = I["[object Int16Array]"] = I["[object Int32Array]"] = I["[object Map]"] = I["[object Number]"] = I[A] = I["[object RegExp]"] = I["[object Set]"] = I["[object String]"] = I["[object Symbol]"] = I["[object Uint8Array]"] = I["[object Uint8ClampedArray]"] = I["[object Uint16Array]"] = I["[object Uint32Array]"] = !0, I["[object Error]"] = I[F] = I["[object WeakMap]"] = !1, e.exports = function e(t, r, E, D, L, C) {
      var M,
          T = r & j,
          B = r & O,
          U = r & S;
      if (E && (M = L ? E(t, D, L, C) : E(t)), void 0 !== M) return M;
      if (!w(t)) return t;
      var W = y(t);

      if (W) {
        if (M = v(t), !T) return c(t, M);
      } else {
        var N = h(t),
            z = N == F || N == P;
        if (b(t)) return s(t, T);

        if (N == A || N == k || z && !L) {
          if (M = B || z ? {} : m(t), !T) return B ? l(t, u(M, t)) : f(t, a(M, t));
        } else {
          if (!I[N]) return L ? t : {};
          M = g(t, N, T);
        }
      }

      C || (C = new n());
      var G = C.get(t);
      if (G) return G;
      if (C.set(t, M), R(t)) return t.forEach(function (n) {
        M.add(e(n, r, E, n, t, C));
      }), M;
      if (x(t)) return t.forEach(function (n, i) {
        M.set(i, e(n, r, E, i, t, C));
      }), M;
      var V = U ? B ? d : p : B ? keysIn : _,
          q = W ? void 0 : V(t);
      return i(q || t, function (n, i) {
        q && (n = t[i = n]), o(M, i, e(n, r, E, i, t, C));
      }), M;
    };
  }, function (e, t, r) {
    var n = r(58)(Object.getPrototypeOf, Object);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(62);

    e.exports = function (e) {
      var t = new e.constructor(e.byteLength);
      return new n(t).set(new n(e)), t;
    };
  }, function (e, t) {
    e.exports = function () {
      throw new Error("define cannot be used indirect");
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function () {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      return function (e) {
        return t.reduceRight(function (e, t) {
          return e.then(t);
        }, Promise.resolve(e));
      };
    };
  }, function (e, t, r) {
    var n = r(106),
        i = r(25),
        o = r(0),
        a = r(26),
        u = r(12),
        s = r(56),
        c = Object.prototype.hasOwnProperty;

    e.exports = function (e, t) {
      var r = o(e),
          f = !r && i(e),
          l = !r && !f && a(e),
          p = !r && !f && !l && s(e),
          d = r || f || l || p,
          h = d ? n(e.length, String) : [],
          v = h.length;

      for (var g in e) {
        !t && !c.call(e, g) || d && ("length" == g || l && ("offset" == g || "parent" == g) || p && ("buffer" == g || "byteLength" == g || "byteOffset" == g) || u(g, v)) || h.push(g);
      }

      return h;
    };
  }, function (e, t, r) {
    (function (t) {
      var r = "object" == typeof t && t && t.Object === Object && t;
      e.exports = r;
    }).call(this, r(108));
  }, function (e, t, r) {
    var n = r(112),
        i = r(28),
        o = r(29),
        a = o && o.isTypedArray,
        u = a ? i(a) : n;
    e.exports = u;
  }, function (e, t, r) {
    var n = r(30),
        i = r(113),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!n(e)) return i(e);
      var t = [];

      for (var r in Object(e)) {
        o.call(e, r) && "constructor" != r && t.push(r);
      }

      return t;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (r) {
        return e(t(r));
      };
    };
  }, function (e, t) {
    var r = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return r.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t, r) {
    var n = r(144),
        i = r(2);

    e.exports = function e(t, r, o, a, u) {
      return t === r || (null == t || null == r || !i(t) && !i(r) ? t != t && r != r : n(t, r, o, a, e, u));
    };
  }, function (e, t, r) {
    var n = r(145),
        i = r(148),
        o = r(149),
        a = 1,
        u = 2;

    e.exports = function (e, t, r, s, c, f) {
      var l = r & a,
          p = e.length,
          d = t.length;
      if (p != d && !(l && d > p)) return !1;
      var h = f.get(e);
      if (h && f.get(t)) return h == t;
      var v = -1,
          g = !0,
          m = r & u ? new n() : void 0;

      for (f.set(e, t), f.set(t, e); ++v < p;) {
        var y = e[v],
            b = t[v];
        if (s) var x = l ? s(b, y, v, t, e, f) : s(y, b, v, e, t, f);

        if (void 0 !== x) {
          if (x) continue;
          g = !1;
          break;
        }

        if (m) {
          if (!i(t, function (e, t) {
            if (!o(m, t) && (y === e || c(y, e, r, s, f))) return m.push(t);
          })) {
            g = !1;
            break;
          }
        } else if (y !== b && !c(y, b, r, s, f)) {
          g = !1;
          break;
        }
      }

      return f.delete(e), f.delete(t), g;
    };
  }, function (e, t, r) {
    var n = r(1).Uint8Array;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(64),
        i = r(37),
        o = r(3);

    e.exports = function (e) {
      return n(e, o, i);
    };
  }, function (e, t, r) {
    var n = r(36),
        i = r(0);

    e.exports = function (e, t, r) {
      var o = t(e);
      return i(e) ? o : n(o, r(e));
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, r) {
    var n = r(6)(r(1), "WeakMap");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(4);

    e.exports = function (e) {
      return e == e && !n(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (r) {
        return null != r && r[e] === t && (void 0 !== t || e in Object(r));
      };
    };
  }, function (e, t, r) {
    var n = r(38);

    e.exports = function (e, t, r) {
      var i = null == e ? void 0 : n(e, t);
      return void 0 === i ? r : i;
    };
  }, function (e, t, r) {
    var n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        i = /\\(\\)?/g,
        o = r(160)(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(n, function (e, r, n, o) {
        t.push(n ? o.replace(i, "$1") : r || e);
      }), t;
    });
    e.exports = o;
  }, function (e, t, r) {
    function n(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(o);

      var r = function r() {
        var n = arguments,
            i = t ? t.apply(this, n) : n[0],
            o = r.cache;
        if (o.has(i)) return o.get(i);
        var a = e.apply(this, n);
        return r.cache = o.set(i, a) || o, a;
      };

      return r.cache = new (n.Cache || i)(), r;
    }

    var i = r(35),
        o = "Expected a function";
    n.Cache = i, e.exports = n;
  }, function (e, t, r) {
    var n = r(161);

    e.exports = function (e) {
      return null == e ? "" : n(e);
    };
  }, function (e, t, r) {
    var n = r(162),
        i = r(163);

    e.exports = function (e, t) {
      return null != e && i(e, t, n);
    };
  }, function (e, t) {
    e.exports = function (e, t, r, n) {
      for (var i = e.length, o = r + (n ? 1 : -1); n ? o-- : ++o < i;) {
        if (t(e[o], o, e)) return o;
      }

      return -1;
    };
  }, function (e, t, r) {
    var n = r(42),
        i = r(19),
        o = r(12),
        a = r(4),
        u = r(8);

    e.exports = function (e, t, r, s) {
      if (!a(e)) return e;

      for (var c = -1, f = (t = i(t, e)).length, l = f - 1, p = e; null != p && ++c < f;) {
        var d = u(t[c]),
            h = r;

        if (c != l) {
          var v = p[d];
          void 0 === (h = s ? s(v, d, p) : void 0) && (h = a(v) ? v : o(t[c + 1]) ? [] : {});
        }

        n(p, d, h), p = p[d];
      }

      return e;
    };
  }, function (e, t, r) {
    var n = r(77);

    e.exports = function (e, t, r) {
      "__proto__" == t && n ? n(e, t, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
      }) : e[t] = r;
    };
  }, function (e, t, r) {
    var n = r(6),
        i = function () {
      try {
        var e = n(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    e.exports = i;
  }, function (e, t, r) {
    var n = r(171)("pick", r(225));
    n.placeholder = r(79), e.exports = n;
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, r) {
    var n = r(40),
        i = r(81),
        o = i ? function (e, t) {
      return i.set(e, t), e;
    } : n;
    e.exports = o;
  }, function (e, t, r) {
    var n = r(66),
        i = n && new n();
    e.exports = i;
  }, function (e, t, r) {
    var n = r(83),
        i = r(84),
        o = r(178),
        a = r(20),
        u = r(85),
        s = r(92),
        c = r(194),
        f = r(48),
        l = r(1),
        p = 1,
        d = 2,
        h = 8,
        v = 16,
        g = 128,
        m = 512;

    e.exports = function e(t, r, y, b, x, w, R, _, j, O) {
      var S = r & g,
          k = r & p,
          F = r & d,
          P = r & (h | v),
          A = r & m,
          I = F ? void 0 : a(t);
      return function p() {
        for (var d = arguments.length, h = Array(d), v = d; v--;) {
          h[v] = arguments[v];
        }

        if (P) var g = s(p),
            m = o(h, g);

        if (b && (h = n(h, b, x, P)), w && (h = i(h, w, R, P)), d -= m, P && d < O) {
          var E = f(h, g);
          return u(t, r, e, p.placeholder, y, h, E, _, j, O - d);
        }

        var D = k ? y : this,
            L = F ? D[t] : t;
        return d = h.length, _ ? h = c(h, _) : A && d > 1 && h.reverse(), S && j < d && (h.length = j), this && this !== l && this instanceof p && (L = I || a(L)), L.apply(D, h);
      };
    };
  }, function (e, t) {
    var r = Math.max;

    e.exports = function (e, t, n, i) {
      for (var o = -1, a = e.length, u = n.length, s = -1, c = t.length, f = r(a - u, 0), l = Array(c + f), p = !i; ++s < c;) {
        l[s] = t[s];
      }

      for (; ++o < u;) {
        (p || o < a) && (l[n[o]] = e[o]);
      }

      for (; f--;) {
        l[s++] = e[o++];
      }

      return l;
    };
  }, function (e, t) {
    var r = Math.max;

    e.exports = function (e, t, n, i) {
      for (var o = -1, a = e.length, u = -1, s = n.length, c = -1, f = t.length, l = r(a - s, 0), p = Array(l + f), d = !i; ++o < l;) {
        p[o] = e[o];
      }

      for (var h = o; ++c < f;) {
        p[h + c] = t[c];
      }

      for (; ++u < s;) {
        (d || o < a) && (p[h + n[u]] = e[o++]);
      }

      return p;
    };
  }, function (e, t, r) {
    var n = r(179),
        i = r(88),
        o = r(90),
        a = 1,
        u = 2,
        s = 4,
        c = 8,
        f = 32,
        l = 64;

    e.exports = function (e, t, r, p, d, h, v, g, m, y) {
      var b = t & c;
      t |= b ? f : l, (t &= ~(b ? l : f)) & s || (t &= ~(a | u));
      var x = [e, t, d, b ? h : void 0, b ? v : void 0, b ? void 0 : h, b ? void 0 : v, g, m, y],
          w = r.apply(void 0, x);
      return n(e) && i(w, x), w.placeholder = p, o(w, e, t);
    };
  }, function (e, t, r) {
    var n = r(81),
        i = r(180),
        o = n ? function (e) {
      return n.get(e);
    } : i;
    e.exports = o;
  }, function (e, t, r) {
    function n(e, t) {
      this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
    }

    var i = r(21),
        o = r(46);
    n.prototype = i(o.prototype), n.prototype.constructor = n, e.exports = n;
  }, function (e, t, r) {
    var n = r(80),
        i = r(89)(n);
    e.exports = i;
  }, function (e, t) {
    var r = 800,
        n = 16,
        i = Date.now;

    e.exports = function (e) {
      var t = 0,
          o = 0;
      return function () {
        var a = i(),
            u = n - (a - o);

        if (o = a, u > 0) {
          if (++t >= r) return arguments[0];
        } else t = 0;

        return e.apply(void 0, arguments);
      };
    };
  }, function (e, t, r) {
    var n = r(185),
        i = r(186),
        o = r(91),
        a = r(189);

    e.exports = function (e, t, r) {
      var u = t + "";
      return o(e, i(u, a(n(u), r)));
    };
  }, function (e, t, r) {
    var n = r(187),
        i = r(89)(n);
    e.exports = i;
  }, function (e, t) {
    e.exports = function (e) {
      return e.placeholder;
    };
  }, function (e, t, r) {
    var n = r(23),
        i = r(3);

    e.exports = function (e, t) {
      return e && n(t, i(t), e);
    };
  }, function (e, t, r) {
    var n = r(54),
        i = r(199),
        o = r(13);

    e.exports = function (e) {
      return o(e) ? n(e, !0) : i(e);
    };
  }, function (e, t, r) {
    var n = r(36),
        i = r(50),
        o = r(37),
        a = r(65),
        u = Object.getOwnPropertySymbols ? function (e) {
      for (var t = []; e;) {
        n(t, o(e)), e = i(e);
      }

      return t;
    } : a;
    e.exports = u;
  }, function (e, t, r) {
    function n(e, t, r) {
      var a = i(e, o, void 0, void 0, void 0, void 0, void 0, t = r ? void 0 : t);
      return a.placeholder = n.placeholder, a;
    }

    var i = r(43),
        o = 8;
    n.placeholder = {}, e.exports = n;
  }, function (e, t, r) {
    var n = r(5),
        i = r(50),
        o = r(2),
        a = "[object Object]",
        u = Function.prototype,
        s = Object.prototype,
        c = u.toString,
        f = s.hasOwnProperty,
        l = c.call(Object);

    e.exports = function (e) {
      if (!o(e) || n(e) != a) return !1;
      var t = i(e);
      if (null === t) return !0;
      var r = f.call(t, "constructor") && t.constructor;
      return "function" == typeof r && r instanceof r && c.call(r) == l;
    };
  }, function (e, t, r) {
    var n = r(220),
        i = r(223),
        o = r(91);

    e.exports = function (e) {
      return o(i(e, void 0, n), e + "");
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return new Error("[FLAMELINK] " + e);
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function i(e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = Array(e.length); t < e.length; t++) {
          r[t] = e[t];
        }

        return r;
      }

      return Array.from(e);
    }

    function o(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function a(e) {
      return function () {
        var t = e.apply(this, arguments);
        return new Promise(function (e, r) {
          return function n(i, o) {
            try {
              var a = t[i](o),
                  u = a.value;
            } catch (e) {
              return void r(e);
            }

            if (!a.done) return Promise.resolve(u).then(function (e) {
              n("next", e);
            }, function (e) {
              n("throw", e);
            });
            e(u);
          }("next");
        });
      };
    }

    function u() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = null,
          r = null,
          n = null,
          u = null,
          O = null,
          S = !1,
          k = Object.assign({}, _.DEFAULT_CONFIG, e),
          F = k.env,
          P = k.locale;
      if (k.firebaseApp) t = k.firebaseApp, k.isAdminApp && (S = !0);else if (!t) {
        var A = k.apiKey,
            I = k.authDomain,
            E = k.databaseURL,
            D = k.storageBucket,
            L = k.projectId;
        if (!(A && I && E && L)) throw (0, x.default)('The following config properties are mandatory: "apiKey", "authDomain", "databaseURL", "projectId"');
        t = c.initializeApp({
          apiKey: A,
          authDomain: I,
          databaseURL: E,
          storageBucket: D,
          projectId: L
        }, L);
      }

      var C = function C(e, r) {
        return e || "function" == typeof t[r] ? t[r]() : null;
      };

      r = C(r, "database"), n = C(n, "storage"), u = C(u, "auth"), O = C(O, "firestore");
      var M = {
        ref: function ref(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getSchemasRefPath)(e || null, F, P));
        },
        getRaw: function getRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = "string" == typeof e ? e : null,
              n = "string" == typeof e ? t : e || {},
              i = (0, R.applyOrderBy)(M.ref(r), n);
          return (0, R.applyFilters)(i, n).once(n.event || "value");
        },
        get: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                a,
                u,
                s,
                c,
                f = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if ("string" != typeof t) {
                      e.next = 10;
                      break;
                    }

                    if (r = (0, R.pluckResultFields)(f.fields), (n = (0, v.default)(j, "schemas[" + F + "]." + t)) && !(0, R.hasNonCacheableOptions)(f)) {
                      e.next = 8;
                      break;
                    }

                    return e.next = 6, M.getRaw(t, f);

                  case 6:
                    i = e.sent, n = i.val();

                  case 8:
                    return a = o({}, t, n), e.abrupt("return", r(a)[t]);

                  case 10:
                    if (f = t || {}, (u = (0, v.default)(j, "schemas[" + F + "]")) && !(0, R.hasNonCacheableOptions)(f)) {
                      e.next = 17;
                      break;
                    }

                    return e.next = 15, M.getRaw(null, f);

                  case 15:
                    s = e.sent, u = s.val();

                  case 17:
                    return c = (0, R.pluckResultFields)(f.fields), e.abrupt("return", c(u));

                  case 19:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getFieldsRaw: function getFieldsRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = "string" == typeof e ? e + "/fields" : null,
              n = "string" == typeof e ? t : e || {},
              i = (0, R.applyOrderBy)(M.ref(r), n);
          return (0, R.applyFilters)(i, n).once(n.event || "value");
        },
        getFields: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                a,
                u,
                s,
                c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if ("string" != typeof t) {
                      e.next = 9;
                      break;
                    }

                    if (r = (0, v.default)(j, "schemas[" + F + "]." + t), (n = r ? r.fields : null) && !(0, R.hasNonCacheableOptions)(c)) {
                      e.next = 8;
                      break;
                    }

                    return e.next = 6, M.getFieldsRaw(t, c);

                  case 6:
                    i = e.sent, n = i.val();

                  case 8:
                    return e.abrupt("return", (0, R.pluckResultFields)(c.fields, n));

                  case 9:
                    if (a = t || {}, (u = (0, v.default)(j, "schemas[" + F + "]")) && !(0, R.hasNonCacheableOptions)(a)) {
                      e.next = 16;
                      break;
                    }

                    return e.next = 14, M.getFieldsRaw(a);

                  case 14:
                    s = e.sent, u = s.val();

                  case 16:
                    return e.abrupt("return", (0, d.default)(u).reduce(function (e, t) {
                      return Object.assign({}, e, o({}, t, (0, R.pluckResultFields)(a.fields, u[t].fields)));
                    }, {}));

                  case 17:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        subscribeRaw: function subscribeRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments[2];

          if ("string" == typeof e) {
            r || (r = t, t = {});
            var n = (0, R.applyOrderBy)(M.ref(e), t);
            return (0, R.applyFilters)(n, t).on(t.event || "value", r);
          }

          r = t, t = e || {}, "object" === (void 0 === r ? "undefined" : s(r)) && (r = e, t = {});
          var i = (0, R.applyOrderBy)(M.ref(null), t);
          return (0, R.applyFilters)(i, t).on(t.event || "value", r);
        },
        subscribe: function subscribe(e) {
          var t,
              r,
              n = this,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              u = arguments[2];

          try {
            if ("string" == typeof e) {
              u && "function" != typeof i || (u = i, i = {});
              var c = (0, R.pluckResultFields)(i.fields);
              return M.subscribeRaw(e, i, (r = a(_regeneratorRuntime.mark(function t(r) {
                var i, a;
                return _regeneratorRuntime.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        return t.next = 2, (0, l.default)(c)(o({}, e, r.val()));

                      case 2:
                        return i = t.sent, a = i[e], t.abrupt("return", u(null, a));

                      case 5:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, n);
              })), function (e) {
                return r.apply(this, arguments);
              }));
            }

            u = i, i = e || {}, "object" === (void 0 === u ? "undefined" : s(u)) && (u = e, i = {});
            var f = (0, R.pluckResultFields)(i.fields);
            return M.subscribeRaw(i, (t = a(_regeneratorRuntime.mark(function e(t) {
              var r;
              return _regeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (0, l.default)(f)(t.val());

                    case 2:
                      r = e.sent, u(null, r);

                    case 4:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, n);
            })), function (e) {
              return t.apply(this, arguments);
            }));
          } catch (e) {
            return u(e);
          }
        },
        unsubscribe: function unsubscribe() {
          if (2 === arguments.length) {
            if (_.ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? void 0 : arguments[1])) return M.ref(arguments.length <= 0 ? void 0 : arguments[0]).off(arguments.length <= 1 ? void 0 : arguments[1]);
            throw (0, x.default)('"' + (arguments.length <= 1 ? void 0 : arguments[1]) + '" is not a valid child event');
          }

          if (1 === arguments.length) return M.ref(arguments.length <= 0 ? void 0 : arguments[0]).off();
          throw (0, x.default)('"unsubscribe" method needs to be called with min 1 argument and max 2 arguments');
        },
        set: function set(e, t) {
          if ("string" != typeof e || "object" !== (void 0 === t ? "undefined" : s(t)) && null !== t) throw (0, x.default)('"set" called with the incorrect arguments. Check the docs for details.');
          var r = "object" === (void 0 === t ? "undefined" : s(t)) ? Object.assign({}, t, {
            __meta__: {
              createdBy: (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
              createdDate: new Date().toISOString()
            },
            id: e
          }) : t;
          return M.ref(e).set(r);
        },
        update: function update(e, t) {
          if ("number" == typeof e && (e = e.toString()), "string" != typeof e || "object" !== (void 0 === t ? "undefined" : s(t)) && null !== t) throw (0, x.default)('"update" called with the incorrect arguments. Check the docs for details.');
          var r = "object" === (void 0 === t ? "undefined" : s(t)) ? Object.assign({}, t, {
            "__meta__/lastModifiedBy": (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
            "__meta__/lastModifiedDate": new Date().toISOString(),
            id: e
          }) : t;
          return M.ref(e).update(r);
        },
        remove: function remove(e) {
          if ("number" == typeof e && (e = e.toString()), "string" != typeof e) throw (0, x.default)('"remove" called with the incorrect arguments. Check the docs for details.');
          return M.ref(e).remove();
        },
        transaction: function transaction(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {};
          if ("number" == typeof e && (e = e.toString()), "string" != typeof e || "function" != typeof t) throw (0, x.default)('"transaction" called with the incorrect arguments. Check the docs for details.');
          return M.ref(e).transaction(t, r);
        }
      },
          T = {
        ref: function ref(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getSettingsRefPath)(e));
        },
        getRaw: function getRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = "string" == typeof e ? e : null,
              n = "string" == typeof e ? t : e || {},
              i = (0, R.applyOrderBy)(T.ref(r), n);
          return (0, R.applyFilters)(i, n).once(n.event || "value");
        },
        get: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                a,
                u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return r = (0, R.pluckResultFields)(u.fields), e.next = 3, T.getRaw(t, u);

                  case 3:
                    return n = e.sent, i = u.needsWrap ? o({}, t, n.val()) : n.val(), e.next = 7, (0, l.default)(r)(i);

                  case 7:
                    return a = e.sent, e.abrupt("return", u.needsWrap ? a[t] : a);

                  case 9:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        setLocale: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t,
                n,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : P;
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, r.ref("/flamelink/settings/locales").once("value");

                  case 2:
                    if (t = e.sent, n = t.val()) {
                      e.next = 6;
                      break;
                    }

                    throw (0, x.default)("No supported locales found.");

                  case 6:
                    if (n.includes(i)) {
                      e.next = 8;
                      break;
                    }

                    throw (0, x.default)('"' + i + '" is not a supported locale. Supported Locales: ' + n.join(", "));

                  case 8:
                    return P = i, e.abrupt("return", P);

                  case 10:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getLocale: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", P);

                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        setEnvironment: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t,
                n,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : F;
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, r.ref("/flamelink/settings/environments").once("value");

                  case 2:
                    if (t = e.sent, n = t.val()) {
                      e.next = 6;
                      break;
                    }

                    throw (0, x.default)("No supported environments found.");

                  case 6:
                    if ((!(0, m.default)(n) || n.includes(i)) && ((0, m.default)(n) || (0, d.default)(n).includes(i))) {
                      e.next = 8;
                      break;
                    }

                    throw (0, x.default)('"' + i + '" is not a supported environment. Supported Environments: ' + n.join(", "));

                  case 8:
                    return F = i, e.abrupt("return", F);

                  case 10:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getEnvironment: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", F);

                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getImageSizes: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", T.get("general/imageSizes", t));

                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getDefaultPermissionsGroup: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", T.get("general/defaultPermissionsGroup", t));

                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getGlobals: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", T.get("globals", Object.assign({}, t, {
                      needsWrap: !0
                    })));

                  case 1:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      },
          B = {
        _getFolderId: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t,
                n,
                i,
                o,
                a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "Root";
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (r) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');

                  case 2:
                    return e.next = 4, r.ref((0, R.getFolderRefPath)()).once("value");

                  case 4:
                    if (t = e.sent, n = t.val(), i = (0, h.default)(n, {
                      name: a
                    })) {
                      e.next = 10;
                      break;
                    }

                    return o = (0, h.default)(n, {
                      name: u
                    }) || {}, e.abrupt("return", o.id);

                  case 10:
                    return e.abrupt("return", i.id);

                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        _getFolderIdFromOptions: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t,
                r,
                n,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t = i.folderId, r = i.folderName, n = i.folderFallback, !t) {
                      e.next = 3;
                      break;
                    }

                    return e.abrupt("return", t);

                  case 3:
                    return e.abrupt("return", B._getFolderId(r, n));

                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        _setFile: function _setFile() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = "object" === (void 0 === e ? "undefined" : s(e)) ? Object.assign({}, e, {
            __meta__: {
              createdBy: (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
              createdDate: new Date().toISOString()
            }
          }) : e;
          return B.fileRef(e.id).set(t);
        },
        _createSizedImage: function () {
          var e = a(_regeneratorRuntime.mark(function e(t, r) {
            var n,
                i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!i || !(i.path || i.width || i.maxWidth)) {
                      e.next = 5;
                      break;
                    }

                    return e.next = 3, (0, b.default)(t, i);

                  case 3:
                    return n = e.sent, e.abrupt("return", B.ref(r, {
                      path: i.path,
                      width: i.width || i.maxWidth
                    }).put(n));

                  case 5:
                    throw (0, x.default)("Invalid size object supplied - please refer to https://flamelink.github.io/flamelink/#/storage?id=upload for more details on upload options.\nImage upload for supplied size skipped for file: " + r);

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        ref: function ref(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!n) throw (0, x.default)('The Storage service is not available. Make sure the "storageBucket" property is provided.');

          if (/:\/\//.test(e)) {
            if (S) throw (0, x.default)("Retrieving files from URL is not supported for the admin SDK");
            return n.refFromURL(e);
          }

          return S ? n.bucket().file((0, R.getStorageRefPath)(e, t)) : n.ref((0, R.getStorageRefPath)(e, t));
        },
        folderRef: function folderRef(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getFolderRefPath)(e));
        },
        fileRef: function fileRef(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getFileRefPath)(e));
        },
        mediaRef: function mediaRef(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getMediaRefPath)(e));
        },
        getRaw: function getRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = "string" == typeof e ? e : null,
              n = "string" == typeof e ? t : e || {},
              i = (0, R.applyOrderBy)(B.mediaRef(r), n);
          return (0, R.applyFilters)(i, n).once(n.event || "value");
        },
        get: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                a,
                u,
                s,
                c,
                f = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if ("string" != typeof t) {
                      e.next = 8;
                      break;
                    }

                    return r = (0, R.pluckResultFields)(f.fields), e.next = 4, B.getRaw(t, f);

                  case 4:
                    return n = e.sent, i = n.val(), a = o({}, t, i), e.abrupt("return", r(a)[t]);

                  case 8:
                    return f = t || {}, u = (0, R.pluckResultFields)(f.fields), e.next = 12, B.getRaw(null, f);

                  case 12:
                    return s = e.sent, c = s.val(), e.abrupt("return", u(c));

                  case 15:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        subscribeRaw: function subscribeRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments[2];

          if ("string" == typeof e) {
            r || (r = t, t = {});
            var n = (0, R.applyOrderBy)(B.mediaRef(e), t);
            return (0, R.applyFilters)(n, t).on(t.event || "value", r);
          }

          r = t, t = e || {}, "object" === (void 0 === r ? "undefined" : s(r)) && (r = e, t = {});
          var i = (0, R.applyOrderBy)(B.mediaRef(null), t);
          return (0, R.applyFilters)(i, t).on(t.event || "value", r);
        },
        subscribe: function subscribe(e) {
          var t,
              r,
              n = this,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              u = arguments[2];

          try {
            if ("string" == typeof e) {
              u && "function" != typeof i || (u = i, i = {});
              var c = (0, R.pluckResultFields)(i.fields);
              return B.subscribeRaw(e, i, (r = a(_regeneratorRuntime.mark(function t(r) {
                var i, a;
                return _regeneratorRuntime.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        return t.next = 2, (0, l.default)(c)(o({}, e, r.val()));

                      case 2:
                        return i = t.sent, a = i[e], t.abrupt("return", u(null, a));

                      case 5:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, n);
              })), function (e) {
                return r.apply(this, arguments);
              }));
            }

            u = i, i = e || {}, "object" === (void 0 === u ? "undefined" : s(u)) && (u = e, i = {});
            var f = (0, R.pluckResultFields)(i.fields);
            return B.subscribeRaw(i, (t = a(_regeneratorRuntime.mark(function e(t) {
              var r;
              return _regeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (0, l.default)(f)(t.val());

                    case 2:
                      r = e.sent, u(null, r);

                    case 4:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, n);
            })), function (e) {
              return t.apply(this, arguments);
            }));
          } catch (e) {
            return u(e);
          }
        },
        unsubscribe: function unsubscribe() {
          if (2 === arguments.length) {
            if (_.ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? void 0 : arguments[1])) return B.mediaRef(arguments.length <= 0 ? void 0 : arguments[0]).off(arguments.length <= 1 ? void 0 : arguments[1]);
            throw (0, x.default)('"' + (arguments.length <= 1 ? void 0 : arguments[1]) + '" is not a valid child event');
          }

          if (1 === arguments.length) return B.mediaRef(arguments.length <= 0 ? void 0 : arguments[0]).off();
          throw (0, x.default)('"unsubscribe" method needs to be called with min 1 argument and max 2 arguments');
        },
        getFoldersRaw: function getFoldersRaw() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = (0, R.applyOrderBy)(B.folderRef(), e);
          return (0, R.applyFilters)(t, e).once(e.event || "value");
        },
        getFolders: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t,
                r,
                n,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t = (0, R.pluckResultFields)(i.fields), r = (0, R.formatStructure)(i.structure, {
                      idProperty: "id",
                      parentProperty: "parentId"
                    }), e.next = 4, B.getFoldersRaw(i);

                  case 4:
                    return n = e.sent, e.abrupt("return", (0, l.default)(t, r, p.default)(n.val()));

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getFileRaw: function getFileRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!e) throw (0, x.default)('"storage.getFileRaw()" should be called with at least the file ID');
          var r = (0, R.applyOrderBy)(B.fileRef(e), t);
          return (0, R.applyFilters)(r, t).once(t.event || "value");
        },
        getFile: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                a,
                u = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"storage.getFile()" should be called with at least the file ID');

                  case 2:
                    return r = (0, R.pluckResultFields)(u.fields), e.next = 5, B.getFileRaw(t, u);

                  case 5:
                    return n = e.sent, i = o({}, t, n.val()), e.next = 9, (0, l.default)(r)(i);

                  case 9:
                    return a = e.sent, e.abrupt("return", a[t]);

                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getFilesRaw: function getFilesRaw() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = (0, R.applyOrderBy)(B.fileRef(), e);
          return (0, R.applyFilters)(t, e).once(e.event || "value");
        },
        getFiles: function () {
          var e = a(_regeneratorRuntime.mark(function e() {
            var t,
                r,
                n,
                i,
                o,
                a,
                u = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t = {
                      folderFallback: null
                    }, r = Object.assign(t, u, u.mediaType ? {
                      orderByChild: "type",
                      equalTo: u.mediaType
                    } : {}), e.next = 4, B._getFolderIdFromOptions(r);

                  case 4:
                    return n = e.sent, i = (0, R.filterByFolderId)(n), o = (0, R.pluckResultFields)(r.fields), e.next = 9, B.getFilesRaw(r);

                  case 9:
                    return a = e.sent, e.abrupt("return", (0, l.default)(o, i)(a.val()));

                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }(),
        getURL: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                o,
                a,
                u,
                c,
                f,
                l,
                p,
                d,
                h,
                g,
                m = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"storage.getURL()" should be called with at least the file ID');

                  case 2:
                    return r = m.size, e.next = 5, B.getFile(t, m);

                  case 5:
                    if (n = e.sent) {
                      e.next = 8;
                      break;
                    }

                    return e.abrupt("return", n);

                  case 8:
                    return o = (i = n || {}).file, a = i.sizes, u = [o], c = function c(e) {
                      var t = a.map(function (e) {
                        return Object.assign({}, e, {
                          width: parseInt(e.width || e.maxWidth, 10)
                        });
                      }, []).sort(function (e, t) {
                        return e.width - t.width;
                      }).find(function (t) {
                        return t.width >= e;
                      });
                      t ? u.push(t) : console.warn("[FLAMELINK]: The provided size (" + r + ") has been ignored because it did not match any of the given file's available sizes.\nAvailable sizes: " + a.map(function (e) {
                        return e.width;
                      }).join(", "));
                    }, "object" === (void 0 === r ? "undefined" : s(r)) ? (f = r.width, l = r.height, p = r.quality, void 0 !== f && void 0 !== l && void 0 !== p && (r.path = f + "_" + l + "_" + Math.round(100 * parseFloat(p, 10))), r.path && a && (0, v.default)(a, "[0].path") ? a.find(function (e) {
                      return e.path === r.path;
                    }) ? u.push({
                      path: r.path
                    }) : console.warn("[FLAMELINK]: The provided path (" + r.path + ") has been ignored because it did not match any of the given file's available paths.\nAvailable paths: " + a.map(function (e) {
                      return e.path;
                    }).join(", ")) : f && a && a.length && c(f)) : r && a && a.length && (d = "device" === r ? (0, R.getScreenResolution)() : r, c(d)), e.next = 14, B.ref.apply(B, u);

                  case 14:
                    if (h = e.sent, !S) {
                      e.next = 20;
                      break;
                    }

                    return e.next = 18, h.getSignedUrl({
                      action: "read",
                      expires: "01-01-2500"
                    });

                  case 18:
                    return g = e.sent, e.abrupt("return", (0, v.default)(g, "[0]", ""));

                  case 20:
                    return e.abrupt("return", h.getDownloadURL());

                  case 21:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getMetadata: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"storage.getMetadata()" should be called with at least the file ID');

                  case 2:
                    return e.next = 4, B.getFile(t, i);

                  case 4:
                    if (r = e.sent) {
                      e.next = 7;
                      break;
                    }

                    throw (0, x.default)('There is no file for File ID: "' + t + '"');

                  case 7:
                    return n = r.file, e.abrupt("return", B.ref(n).getMetadata());

                  case 9:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        updateMetadata: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"storage.updateMetadata()" should be called with at least the file ID');

                  case 2:
                    return e.next = 4, B.getFile(t);

                  case 4:
                    if (r = e.sent) {
                      e.next = 7;
                      break;
                    }

                    throw (0, x.default)('There is no file for File ID: "' + t + '"');

                  case 7:
                    return n = r.file, e.abrupt("return", B.ref(n).updateMetadata(i));

                  case 9:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        deleteFile: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                o,
                u = this,
                s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!S) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"storage.deleteFile()" is not currently supported for server-side use.');

                  case 2:
                    if (t) {
                      e.next = 4;
                      break;
                    }

                    throw (0, x.default)('"storage.deleteFile()" should be called with at least the file ID');

                  case 4:
                    return e.next = 6, B.getFile(t, s);

                  case 6:
                    if (r = e.sent) {
                      e.next = 9;
                      break;
                    }

                    return e.abrupt("return", r);

                  case 9:
                    return n = r.file, i = r.sizes, o = B.ref(n), e.next = 13, o.delete();

                  case 13:
                    if (!Array.isArray(i)) {
                      e.next = 16;
                      break;
                    }

                    return e.next = 16, Promise.all(i.map(function () {
                      var e = a(_regeneratorRuntime.mark(function e(t) {
                        var r, i;
                        return _regeneratorRuntime.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                if (r = t.width || t.maxWidth, i = t.path, r || i) {
                                  e.next = 4;
                                  break;
                                }

                                return e.abrupt("return", Promise.resolve());

                              case 4:
                                return e.abrupt("return", B.ref(n, {
                                  width: r,
                                  path: i
                                }).delete());

                              case 5:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e, u);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }()));

                  case 16:
                    return e.abrupt("return", B.fileRef(t).remove());

                  case 17:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        upload: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                o,
                a,
                u,
                c,
                f,
                l,
                p,
                d,
                h,
                m,
                y,
                b,
                w = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!S) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"storage.upload()" is not currently supported for server-side use.');

                  case 2:
                    return r = w.sizes, n = w.overwriteSizes, e.next = 5, T.getImageSizes();

                  case 5:
                    return o = e.sent, r || n ? r && r.length && !n && (0, g.default)(w, "sizes", [].concat(i(o), i(r)) || []) : (0, g.default)(w, "sizes", o || []), (!w.sizes || w.sizes && 0 === w.sizes.length || Array.isArray(w.sizes) && 0 === w.sizes.filter(function (e) {
                      return !(e.width !== _.DEFAULT_REQUIRED_IMAGE_SIZE && e.maxWidth !== _.DEFAULT_REQUIRED_IMAGE_SIZE || e.height || e.quality);
                    }).length) && (Array.isArray(w.sizes) ? w.sizes.push({
                      width: _.DEFAULT_REQUIRED_IMAGE_SIZE
                    }) : (0, g.default)(w, "sizes", [{
                      width: _.DEFAULT_REQUIRED_IMAGE_SIZE
                    }])), a = Date.now().toString(), u = (0, v.default)(w, "metadata", {}), c = "object" === (void 0 === t ? "undefined" : s(t)) && t.name || "string" == typeof u.name ? a + "_" + (u.name || t.name) : a, f = B.ref(c, w), l = "string" == typeof t ? "putString" : "put", p = [t], e.next = 16, B._getFolderIdFromOptions(w);

                  case 16:
                    return "number" == typeof (d = e.sent) && (d = d.toString()), (0, g.default)(w, "metadata.customMetadata.flamelinkFileId", a), (0, g.default)(w, "metadata.customMetadata.flamelinkFolderId", d), p.push(w.metadata), "putString" === l && w.stringEncoding && p.splice(1, 0, w.stringEncoding), h = f[l].apply(f, p), e.next = 25, h;

                  case 25:
                    if (m = e.sent, y = /^image\//.test((0, v.default)(m, "metadata.contentType")) ? "images" : "files", b = {
                      id: a,
                      file: (0, v.default)(m, "metadata.name", ""),
                      folderId: d,
                      type: y,
                      contentType: (0, v.default)(m, "metadata.contentType", "")
                    }, "images" !== y || "put" !== l || !Array.isArray(w.sizes)) {
                      e.next = 32;
                      break;
                    }

                    return b.sizes = w.sizes.map(function (e) {
                      var t = e.width,
                          r = e.height,
                          n = e.quality;
                      return void 0 !== t && void 0 !== r && void 0 !== n ? Object.assign({}, e, {
                        path: t + "_" + r + "_" + Math.round(100 * n)
                      }) : e;
                    }), e.next = 32, Promise.all(b.sizes.map(function (e) {
                      return B._createSizedImage(t, c, e);
                    }));

                  case 32:
                    return e.next = 34, B._setFile(b);

                  case 34:
                    return e.abrupt("return", h);

                  case 35:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      },
          U = {
        ref: function ref(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getContentRefPath)(e, F, P));
        },
        getRaw: function getRaw(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          if (["string", "number"].includes(void 0 === t ? "undefined" : s(t))) {
            var n = (0, R.applyOrderBy)(U.ref([e, t]), r);
            return (0, R.applyFilters)(n, r).once(r.event || "value");
          }

          var i = "string" == typeof e ? e : null,
              o = "string" == typeof e ? t || {} : e || {},
              a = (0, R.applyOrderBy)(U.ref(i), o);
          return (0, R.applyFilters)(a, o).once(o.event || "value");
        },
        get: function () {
          var e = a(_regeneratorRuntime.mark(function e(t, r) {
            var n,
                i,
                a,
                u,
                c,
                f,
                p,
                h,
                v,
                g,
                m,
                y,
                b,
                x,
                w,
                _,
                j,
                O,
                S = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!["string", "number"].includes(void 0 === r ? "undefined" : s(r))) {
                      e.next = 11;
                      break;
                    }

                    return n = (0, R.pluckResultFields)(S.fields), i = (0, R.populateEntry)(M, U, B, t, S.populate), e.next = 5, U.getRaw(t, r, S);

                  case 5:
                    return a = e.sent, u = o({}, r, a.val()), e.next = 9, (0, l.default)(i, n)(u);

                  case 9:
                    return c = e.sent, e.abrupt("return", c[r]);

                  case 11:
                    return e.next = 13, M.get(t);

                  case 13:
                    return f = e.sent, p = f && "single" === f.type, h = "string" == typeof t ? t : null, v = "string" == typeof t ? r || {} : t || {}, g = (0, R.pluckResultFields)(v.fields), m = (0, R.populateEntry)(M, U, B, t, v.populate), e.next = 21, U.getRaw(h, v);

                  case 21:
                    if (y = e.sent, !h) {
                      e.next = 28;
                      break;
                    }

                    return b = p ? o({}, h, y.val()) : y.val(), e.next = 26, (0, l.default)(m, g)(b);

                  case 26:
                    return x = e.sent, e.abrupt("return", p ? x[h] : x);

                  case 28:
                    return w = y.val(), _ = P, j = (0, d.default)(w).reduce(function (e, t) {
                      return Object.assign({}, e, o({}, t, w[t][_]));
                    }, {}), e.next = 33, (0, l.default)(m, g)(j);

                  case 33:
                    return O = e.sent, e.abrupt("return", O);

                  case 35:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        getByFieldRaw: function getByFieldRaw(e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              i = Object.assign({}, n, {
            orderByChild: t,
            equalTo: r
          });
          return U.getRaw(e, i);
        },
        getByField: function getByField(e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              i = Object.assign({}, n, {
            orderByChild: t,
            equalTo: r
          });
          return U.get(e, i);
        },
        subscribeRaw: function subscribeRaw(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              n = arguments[3];

          if (["string", "number"].includes(void 0 === t ? "undefined" : s(t))) {
            n || (n = r, r = {});
            var i = (0, R.applyOrderBy)(U.ref([e, t]), r);
            return (0, R.applyFilters)(i, r).on(r.event || "value", n);
          }

          if ("object" === (void 0 === t ? "undefined" : s(t))) n = r, r = t;else if ("function" == typeof t) n = t, r = {};else {
            if ("function" != typeof e) throw (0, x.default)("Check out the docs for the required parameters for this method");
            n = e, r = {}, e = null;
          }
          var o = (0, R.applyOrderBy)(U.ref(e), r);
          return (0, R.applyFilters)(o, r).on(r.event || "value", n);
        },
        subscribe: function () {
          var e = a(_regeneratorRuntime.mark(function e(t, r) {
            var n,
                i,
                u,
                c,
                f,
                p,
                h = this,
                v = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                g = arguments[3];
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (e.prev = 0, !["string", "number"].includes(void 0 === r ? "undefined" : s(r))) {
                      e.next = 6;
                      break;
                    }

                    return g || (g = v, v = {}), n = (0, R.pluckResultFields)(v.fields), i = (0, R.populateEntry)(M, U, B, t, v.populate), e.abrupt("return", U.subscribeRaw(t, r, v, function () {
                      var e = a(_regeneratorRuntime.mark(function e(t) {
                        var a, u;
                        return _regeneratorRuntime.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return a = o({}, r, t.val()), e.next = 3, (0, l.default)(i, n)(a);

                              case 3:
                                u = e.sent, g(null, u[r]);

                              case 5:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e, h);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }()));

                  case 6:
                    if ("object" !== (void 0 === r ? "undefined" : s(r))) {
                      e.next = 11;
                      break;
                    }

                    g = v, v = r, e.next = 23;
                    break;

                  case 11:
                    if ("function" != typeof r) {
                      e.next = 16;
                      break;
                    }

                    g = r, v = {}, e.next = 23;
                    break;

                  case 16:
                    if ("function" != typeof t) {
                      e.next = 22;
                      break;
                    }

                    g = t, v = {}, t = null, e.next = 23;
                    break;

                  case 22:
                    throw (0, x.default)("Check out the docs for the required parameters for this method");

                  case 23:
                    return e.next = 25, M.get(t);

                  case 25:
                    return u = e.sent, c = u && "single" === u.type, f = (0, R.pluckResultFields)(v.fields), p = (0, R.populateEntry)(M, U, B, t, v.populate), e.abrupt("return", U.subscribeRaw(t, v, function () {
                      var e = a(_regeneratorRuntime.mark(function e(r) {
                        var n, i, a, u, s, v;
                        return _regeneratorRuntime.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                if (!t) {
                                  e.next = 7;
                                  break;
                                }

                                return n = c ? o({}, t, r.val()) : r.val(), e.next = 4, (0, l.default)(p, f)(n);

                              case 4:
                                return i = e.sent, g(null, c ? i[t] : i), e.abrupt("return");

                              case 7:
                                return a = r.val(), u = P, s = (0, d.default)(a).reduce(function (e, t) {
                                  return Object.assign({}, e, o({}, t, a[t][u]));
                                }, {}), e.next = 12, (0, l.default)(p, f)(s);

                              case 12:
                                v = e.sent, g(null, v);

                              case 14:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e, h);
                      }));
                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }()));

                  case 32:
                    return e.prev = 32, e.t0 = e.catch(0), e.abrupt("return", g(e.t0));

                  case 35:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[0, 32]]);
          }));
          return function (t, r) {
            return e.apply(this, arguments);
          };
        }(),
        unsubscribe: function unsubscribe() {
          if (3 === arguments.length) return U.ref([arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1]]).off(arguments.length <= 2 ? void 0 : arguments[2]);
          if (2 === arguments.length) return _.ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? void 0 : arguments[1]) ? U.ref(arguments.length <= 0 ? void 0 : arguments[0]).off(arguments.length <= 1 ? void 0 : arguments[1]) : U.ref([arguments.length <= 0 ? void 0 : arguments[0], arguments.length <= 1 ? void 0 : arguments[1]]).off();
          if (1 === arguments.length) return U.ref(arguments.length <= 0 ? void 0 : arguments[0]).off();
          throw (0, x.default)('"unsubscribe" method needs to be called with min 1 argument and max 3 arguments');
        },
        set: function () {
          var e = a(_regeneratorRuntime.mark(function e(t, r, n) {
            var i, a, c, l, p, d, h, g, m;
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, M.get(t);

                  case 2:
                    if (i = e.sent, a = i && "single" === i.type, c = a ? r : n, !(a && ("string" != typeof t || "object" !== (void 0 === c ? "undefined" : s(c)) && null !== c) || !a && ("string" != typeof t || "string" != typeof r || "object" !== (void 0 === c ? "undefined" : s(c)) && null !== c))) {
                      e.next = 7;
                      break;
                    }

                    throw (0, x.default)('"set" called with the incorrect arguments. Check the docs for details.');

                  case 7:
                    if (l = i.fields, d = (p = void 0 === l ? [] : l).reduce(function (e, t) {
                      return Object.assign({}, e, o({}, t.key, (0, R.prepConstraintsForValidate)(t.constraints)));
                    }, {}), !(h = (0, f.default)(c, d))) {
                      e.next = 12;
                      break;
                    }

                    return e.abrupt("return", Promise.reject(h));

                  case 12:
                    if (g = p.map(function (e) {
                      return e.key;
                    }), m = (0, y.default)(g), "object" === (void 0 === c ? "undefined" : s(c)) && (c = Object.assign({}, m(c), {
                      __meta__: {
                        createdBy: (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
                        createdDate: new Date().toISOString()
                      },
                      id: a ? t : r
                    })), !a) {
                      e.next = 17;
                      break;
                    }

                    return e.abrupt("return", U.ref(t).set(c));

                  case 17:
                    return e.abrupt("return", U.ref([t, r]).set(c));

                  case 18:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        update: function () {
          var e = a(_regeneratorRuntime.mark(function e(t, r, n) {
            var i, a, c, l, p, h, g, m, b;
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return "number" == typeof r && (r = r.toString()), e.next = 3, M.get(t);

                  case 3:
                    if (i = e.sent, a = i && "single" === i.type, c = a ? r : n, !(a && ("string" != typeof t || "object" !== (void 0 === c ? "undefined" : s(c)) && null !== c) || !a && ("string" != typeof t || "string" != typeof r || "object" !== (void 0 === c ? "undefined" : s(c)) && null !== c))) {
                      e.next = 8;
                      break;
                    }

                    throw (0, x.default)('"update" called with the incorrect arguments. Check the docs for details.');

                  case 8:
                    if (l = i.fields, h = (p = void 0 === l ? [] : l).reduce(function (e, t) {
                      return Object.assign({}, e, o({}, t.key, (0, R.prepConstraintsForValidate)(t.constraints)));
                    }, {}), g = (0, d.default)(c).reduce(function (e, t) {
                      var r = f.default.single(c[t], h[t]);
                      return r ? Object.assign({}, e, o({}, t, r)) : e;
                    }, {}), m = p.map(function (e) {
                      return e.key;
                    }), b = (0, y.default)(m), !(0, d.default)(g).length) {
                      e.next = 15;
                      break;
                    }

                    return e.abrupt("return", Promise.reject(g));

                  case 15:
                    if ("object" === (void 0 === c ? "undefined" : s(c)) && (c = Object.assign({}, b(c), {
                      "__meta__/lastModifiedBy": (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
                      "__meta__/lastModifiedDate": new Date().toISOString(),
                      id: a ? t : r
                    })), !a) {
                      e.next = 18;
                      break;
                    }

                    return e.abrupt("return", U.ref(t).update(c));

                  case 18:
                    return e.abrupt("return", U.ref([t, r]).update(c));

                  case 19:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t, r, n) {
            return e.apply(this, arguments);
          };
        }(),
        remove: function remove(e, t) {
          if ("number" == typeof t && (t = t.toString()), "string" != typeof e || "string" != typeof t) throw (0, x.default)('"remove" called with the incorrect arguments. Check the docs for details.');
          return U.ref([e, t]).remove();
        },
        transaction: function transaction(e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {};
          if ("number" == typeof t && (t = t.toString()), "string" != typeof e || "string" != typeof t || "function" != typeof r) throw (0, x.default)('"transaction" called with the incorrect arguments. Check the docs for details.');
          return U.ref([e, t]).transaction(r, n);
        }
      },
          W = {
        ref: function ref(e) {
          if (!r) throw (0, x.default)('The Database service is not available. Make sure the "databaseURL" property is provided.');
          return r.ref((0, R.getNavigationRefPath)(e, F, P));
        },
        getRaw: function getRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = "string" == typeof e ? e : null,
              n = "string" == typeof e ? t : e || {},
              i = (0, R.applyOrderBy)(W.ref(r), n);
          return (0, R.applyFilters)(i, n).once(n.event || "value");
        },
        get: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                a,
                u,
                s,
                c,
                f,
                l,
                p = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if ("string" != typeof t) {
                      e.next = 11;
                      break;
                    }

                    return e.next = 3, W.getRaw(t, p);

                  case 3:
                    return r = e.sent, e.next = 6, (0, R.pluckResultFields)(p.fields, o({}, t, r.val()));

                  case 6:
                    if (n = e.sent, !(i = n[t]) || !i.hasOwnProperty("items")) {
                      e.next = 10;
                      break;
                    }

                    return e.abrupt("return", Object.assign({}, i, {
                      items: (0, R.formatStructure)(p.structure, {
                        idProperty: "uuid",
                        parentProperty: "parentIndex"
                      }, i.items)
                    }));

                  case 10:
                    return e.abrupt("return", i);

                  case 11:
                    return a = t || {}, e.next = 14, W.getRaw(a);

                  case 14:
                    return u = e.sent, s = u.val(), c = P, f = (0, d.default)(s).reduce(function (e, t) {
                      return Object.assign({}, e, o({}, t, s[t][c]));
                    }, {}), e.next = 20, (0, R.pluckResultFields)(a.fields, f);

                  case 20:
                    return l = e.sent, e.abrupt("return", (0, d.default)(l).reduce(function (e, t) {
                      var r = l[t];

                      if (r && r.hasOwnProperty("items")) {
                        var n = Object.assign({}, r, {
                          items: (0, R.formatStructure)(a.structure, {
                            idProperty: "uuid",
                            parentProperty: "parentIndex"
                          }, r.items)
                        });
                        return Object.assign({}, e, o({}, t, n));
                      }

                      return Object.assign({}, e, o({}, t, r));
                    }, {}));

                  case 22:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        getItemsRaw: function getItemsRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!e) throw (0, x.default)('"getItemsRaw" method requires a navigation reference');
          var r = (0, R.applyOrderBy)(W.ref(e).child("items"), t);
          return (0, R.applyFilters)(r, t).once(t.event || "value");
        },
        getItems: function () {
          var e = a(_regeneratorRuntime.mark(function e(t) {
            var r,
                n,
                i,
                o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return _regeneratorRuntime.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t) {
                      e.next = 2;
                      break;
                    }

                    throw (0, x.default)('"getItems" method requires a navigation reference');

                  case 2:
                    return r = (0, R.pluckResultFields)(o.fields), n = (0, R.formatStructure)(o.structure, {
                      idProperty: "uuid",
                      parentProperty: "parentIndex"
                    }), e.next = 6, W.getItemsRaw(t, o);

                  case 6:
                    return i = e.sent, e.abrupt("return", (0, l.default)(r, n)(i.val()));

                  case 8:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        subscribeRaw: function subscribeRaw(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments[2];

          if ("string" == typeof e) {
            r || (r = t, t = {});
            var n = (0, R.applyOrderBy)(W.ref(e), t);
            return (0, R.applyFilters)(n, t).on(t.event || "value", r);
          }

          r = t, t = e, "object" === (void 0 === r ? "undefined" : s(r)) && (r = e, t = {});
          var i = (0, R.applyOrderBy)(W.ref(null), t);
          return (0, R.applyFilters)(i, t).on(t.event || "value", r);
        },
        subscribe: function subscribe(e) {
          var t,
              r,
              n = this,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              u = arguments[2];

          try {
            if ("string" == typeof e) {
              u && "function" != typeof i || (u = i, i = {});
              var c = (0, R.pluckResultFields)(i.fields);
              return W.subscribeRaw(e, i, (r = a(_regeneratorRuntime.mark(function t(r) {
                var a, s;
                return _regeneratorRuntime.wrap(function (t) {
                  for (;;) {
                    switch (t.prev = t.next) {
                      case 0:
                        return t.next = 2, (0, l.default)(c)(o({}, e, r.val()));

                      case 2:
                        return a = t.sent, (s = a[e]) && s.hasOwnProperty("items") && (s.items = (0, R.formatStructure)(i.structure, {
                          idProperty: "uuid",
                          parentProperty: "parentIndex"
                        }, s.items)), t.abrupt("return", u(null, s));

                      case 6:
                      case "end":
                        return t.stop();
                    }
                  }
                }, t, n);
              })), function (e) {
                return r.apply(this, arguments);
              }));
            }

            u = i, i = e, "object" === (void 0 === u ? "undefined" : s(u)) && (u = e, i = {});
            var f = (0, R.pluckResultFields)(i.fields);
            return W.subscribeRaw(i, (t = a(_regeneratorRuntime.mark(function e(t) {
              var r, a, s, c, p;
              return _regeneratorRuntime.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      return r = t.val(), a = P, s = (0, d.default)(r).reduce(function (e, t) {
                        return Object.assign({}, e, o({}, t, r[t][a]));
                      }, {}), e.next = 5, (0, l.default)(f)(s);

                    case 5:
                      c = e.sent, p = (0, d.default)(c).reduce(function (e, t) {
                        var r = c[t];

                        if (r && r.hasOwnProperty("items")) {
                          var n = Object.assign({}, r, {
                            items: (0, R.formatStructure)(i.structure, {
                              idProperty: "uuid",
                              parentProperty: "parentIndex"
                            }, r.items)
                          });
                          return Object.assign({}, e, o({}, t, n));
                        }

                        return Object.assign({}, e, o({}, t, r));
                      }, {}), u(null, p);

                    case 8:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, n);
            })), function (e) {
              return t.apply(this, arguments);
            }));
          } catch (e) {
            return u(e);
          }
        },
        unsubscribe: function unsubscribe() {
          if (2 === arguments.length) {
            if (_.ALLOWED_CHILD_EVENTS.includes(arguments.length <= 1 ? void 0 : arguments[1])) return W.ref(arguments.length <= 0 ? void 0 : arguments[0]).off(arguments.length <= 1 ? void 0 : arguments[1]);
            throw (0, x.default)('"' + (arguments.length <= 1 ? void 0 : arguments[1]) + '" is not a valid child event');
          }

          if (1 === arguments.length) return W.ref(arguments.length <= 0 ? void 0 : arguments[0]).off();
          throw (0, x.default)('"unsubscribe" method needs to be called with min 1 argument and max 2 arguments');
        },
        set: function set(e, t) {
          if ("string" != typeof e || "object" !== (void 0 === t ? "undefined" : s(t)) && null !== t) throw (0, x.default)('"set" called with the incorrect arguments. Check the docs for details.');
          var r = "object" === (void 0 === t ? "undefined" : s(t)) ? Object.assign({}, t, {
            __meta__: {
              createdBy: (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
              createdDate: new Date().toISOString()
            },
            id: e
          }) : t;
          return W.ref(e).set(r);
        },
        update: function update(e, t) {
          if ("string" != typeof e || "object" !== (void 0 === t ? "undefined" : s(t)) && null !== t) throw (0, x.default)('"update" called with the incorrect arguments. Check the docs for details.');
          var r = "object" === (void 0 === t ? "undefined" : s(t)) ? Object.assign({}, t, {
            "__meta__/lastModifiedBy": (0, v.default)(u, "currentUser.uid", "UNKNOWN"),
            "__meta__/lastModifiedDate": new Date().toISOString(),
            id: e
          }) : t;
          return W.ref(e).update(r);
        },
        remove: function remove(e) {
          if ("string" != typeof e) throw (0, x.default)('"remove" called with the incorrect arguments. Check the docs for details.');
          return W.ref(e).remove();
        },
        transaction: function transaction(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {};
          if ("string" != typeof e || "function" != typeof t) throw (0, x.default)('"transaction" called with the incorrect arguments. Check the docs for details.');
          return W.ref(e).transaction(t, r);
        }
      };
      return M.subscribe(null, function (e, t) {
        return e ? console.error(e) : (0, g.default)(j, "schemas[" + F + "]", t);
      }), {
        name: t.name,
        firebaseApp: t,
        databaseService: r,
        storageService: n,
        authService: u,
        firestoreService: O,
        setLocale: function setLocale() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : P;
          return (0, w.default)("app.setLocale()", 'Use the "app.settings.setLocale()" method instead.'), new Promise(function (t, n) {
            r.ref("/flamelink/settings/locales").once("value").then(function (r) {
              var i = r.val();
              return i ? i.includes(e) ? t(P = e) : n((0, x.default)('"' + e + '" is not a supported locale. Supported Locales: ' + i.join(", "))) : n((0, x.default)("No supported locales found."));
            }).catch(n);
          });
        },
        setEnv: function setEnv() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : F;
          return (0, w.default)("app.setEnv()", 'Use the "app.settings.setEnv()" method instead.'), new Promise(function (t, n) {
            r.ref("/flamelink/settings/environments").once("value").then(function (r) {
              var i = r.val();
              return i ? i.includes(e) ? t(F = e) : n((0, x.default)('"' + e + '" is not a supported environment. Supported Environments: ' + i.join(", "))) : n((0, x.default)("No supported environments found."));
            }).catch(n);
          });
        },
        getLocale: function getLocale() {
          return (0, w.default)("app.getLocale()", 'Use the "app.settings.getLocale()" method instead.'), Promise.resolve(P);
        },
        getEnv: function getEnv() {
          return (0, w.default)("app.getEnv()", 'Use the "app.settings.getEnv()" method instead.'), Promise.resolve(F);
        },
        content: U,
        nav: W,
        schemas: M,
        storage: B,
        settings: T
      };
    }

    var s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    r(101);

    var c = function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    }(r(102)),
        f = n(r(103)),
        l = n(r(53)),
        p = n(r(104)),
        d = n(r(3)),
        h = n(r(114)),
        v = n(r(69)),
        g = n(r(170)),
        m = n(r(0)),
        y = n(r(78)),
        b = n(r(228));

    r(230);

    var x = n(r(99)),
        w = n(r(231)),
        R = r(232),
        _ = r(242),
        j = {};

    u.VERSION = "0.19.12", e.exports = u;
  }, function (e, t) {
    !function (t) {
      "use strict";

      function r(e, t, r, o) {
        var a = t && t.prototype instanceof i ? t : i,
            u = Object.create(a.prototype),
            s = new p(o || []);
        return u._invoke = function (e, t, r) {
          var i = j;
          return function (o, a) {
            if (i === S) throw new Error("Generator is already running");

            if (i === k) {
              if ("throw" === o) throw a;
              return h();
            }

            for (r.method = o, r.arg = a;;) {
              var u = r.delegate;

              if (u) {
                var s = c(u, r);

                if (s) {
                  if (s === F) continue;
                  return s;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (i === j) throw i = k, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              i = S;
              var f = n(e, t, r);

              if ("normal" === f.type) {
                if (i = r.done ? k : O, f.arg === F) continue;
                return {
                  value: f.arg,
                  done: r.done
                };
              }

              "throw" === f.type && (i = k, r.method = "throw", r.arg = f.arg);
            }
          };
        }(e, r, s), u;
      }

      function n(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      function i() {}

      function o() {}

      function a() {}

      function u(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function s(e) {
        var t;

        this._invoke = function (r, i) {
          function o() {
            return new Promise(function (t, o) {
              !function t(r, i, o, a) {
                var u = n(e[r], e, i);

                if ("throw" !== u.type) {
                  var s = u.arg,
                      c = s.value;
                  return c && "object" == typeof c && m.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                    t("next", e, o, a);
                  }, function (e) {
                    t("throw", e, o, a);
                  }) : Promise.resolve(c).then(function (e) {
                    s.value = e, o(s);
                  }, a);
                }

                a(u.arg);
              }(r, i, t, o);
            });
          }

          return t = t ? t.then(o, o) : o();
        };
      }

      function c(e, t) {
        var r = e.iterator[t.method];

        if (r === v) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = v, c(e, t), "throw" === t.method)) return F;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return F;
        }

        var i = n(r, e.iterator, t.arg);
        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, F;
        var o = i.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = v), t.delegate = null, F) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, F);
      }

      function f(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function l(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function p(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(f, this), this.reset(!0);
      }

      function d(e) {
        if (e) {
          var t = e[b];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var r = -1,
                n = function t() {
              for (; ++r < e.length;) {
                if (m.call(e, r)) return t.value = e[r], t.done = !1, t;
              }

              return t.value = v, t.done = !0, t;
            };

            return n.next = n;
          }
        }

        return {
          next: h
        };
      }

      function h() {
        return {
          value: v,
          done: !0
        };
      }

      var v,
          g = Object.prototype,
          m = g.hasOwnProperty,
          y = "function" == typeof Symbol ? Symbol : {},
          b = y.iterator || "@@iterator",
          x = y.asyncIterator || "@@asyncIterator",
          w = y.toStringTag || "@@toStringTag",
          R = "object" == typeof e,
          _ = t.regeneratorRuntime;
      if (_) R && (e.exports = _);else {
        (_ = t.regeneratorRuntime = R ? e.exports : {}).wrap = r;
        var j = "suspendedStart",
            O = "suspendedYield",
            S = "executing",
            k = "completed",
            F = {},
            P = {};

        P[b] = function () {
          return this;
        };

        var A = Object.getPrototypeOf,
            I = A && A(A(d([])));
        I && I !== g && m.call(I, b) && (P = I);
        var E = a.prototype = i.prototype = Object.create(P);
        o.prototype = E.constructor = a, a.constructor = o, a[w] = o.displayName = "GeneratorFunction", _.isGeneratorFunction = function (e) {
          var t = "function" == typeof e && e.constructor;
          return !!t && (t === o || "GeneratorFunction" === (t.displayName || t.name));
        }, _.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, a) : (e.__proto__ = a, w in e || (e[w] = "GeneratorFunction")), e.prototype = Object.create(E), e;
        }, _.awrap = function (e) {
          return {
            __await: e
          };
        }, u(s.prototype), s.prototype[x] = function () {
          return this;
        }, _.AsyncIterator = s, _.async = function (e, t, n, i) {
          var o = new s(r(e, t, n, i));
          return _.isGeneratorFunction(t) ? o : o.next().then(function (e) {
            return e.done ? e.value : o.next();
          });
        }, u(E), E[w] = "Generator", E[b] = function () {
          return this;
        }, E.toString = function () {
          return "[object Generator]";
        }, _.keys = function (e) {
          var t = [];

          for (var r in e) {
            t.push(r);
          }

          return t.reverse(), function r() {
            for (; t.length;) {
              var n = t.pop();
              if (n in e) return r.value = n, r.done = !1, r;
            }

            return r.done = !0, r;
          };
        }, _.values = d, p.prototype = {
          constructor: p,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = v, this.done = !1, this.delegate = null, this.method = "next", this.arg = v, this.tryEntries.forEach(l), !e) for (var t in this) {
              "t" === t.charAt(0) && m.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = v);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            function t(t, n) {
              return o.type = "throw", o.arg = e, r.next = t, n && (r.method = "next", r.arg = v), !!n;
            }

            if (this.done) throw e;

            for (var r = this, n = this.tryEntries.length - 1; n >= 0; --n) {
              var i = this.tryEntries[n],
                  o = i.completion;
              if ("root" === i.tryLoc) return t("end");

              if (i.tryLoc <= this.prev) {
                var a = m.call(i, "catchLoc"),
                    u = m.call(i, "finallyLoc");

                if (a && u) {
                  if (this.prev < i.catchLoc) return t(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return t(i.finallyLoc);
                } else if (a) {
                  if (this.prev < i.catchLoc) return t(i.catchLoc, !0);
                } else {
                  if (!u) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return t(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var n = this.tryEntries[r];

              if (n.tryLoc <= this.prev && m.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
                var i = n;
                break;
              }
            }

            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
            var o = i ? i.completion : {};
            return o.type = e, o.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, F) : this.complete(o);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), F;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var r = this.tryEntries[t];
              if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), l(r), F;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var r = this.tryEntries[t];

              if (r.tryLoc === e) {
                var n = r.completion;

                if ("throw" === n.type) {
                  var i = n.arg;
                  l(r);
                }

                return i;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, t, r) {
            return this.delegate = {
              iterator: d(e),
              resultName: t,
              nextLoc: r
            }, "next" === this.method && (this.arg = v), F;
          }
        };
      }
    }(function () {
      return this;
    }() || Function("return this")());
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    (function (e) {
      (function (e, t, n) {
        "use strict";

        var i = function i(e, t, r) {
          r = o.extend({}, o.options, r);
          var n = o.runValidations(e, t, r);
          if (n.some(function (e) {
            return o.isPromise(e.error);
          })) throw new Error("Use validate.async if you want support for promises");
          return i.processValidationResults(n, r);
        },
            o = i;

        o.extend = function (e) {
          return [].slice.call(arguments, 1).forEach(function (t) {
            for (var r in t) {
              e[r] = t[r];
            }
          }), e;
        }, o.extend(i, {
          version: {
            major: 0,
            minor: 12,
            patch: 0,
            metadata: null,
            toString: function toString() {
              var e = o.format("%{major}.%{minor}.%{patch}", o.version);
              return o.isEmpty(o.version.metadata) || (e += "+" + o.version.metadata), e;
            }
          },
          Promise: "undefined" != typeof Promise ? Promise : null,
          EMPTY_STRING_REGEXP: /^\s*$/,
          runValidations: function runValidations(e, t, r) {
            var n,
                i,
                a,
                u,
                s,
                c,
                f,
                l = [];

            for (n in (o.isDomElement(e) || o.isJqueryElement(e)) && (e = o.collectFormValues(e)), t) {
              for (i in a = o.getDeepObjectValue(e, n), u = o.result(t[n], a, e, n, r, t)) {
                if (!(s = o.validators[i])) throw f = o.format("Unknown validator %{name}", {
                  name: i
                }), new Error(f);
                c = u[i], (c = o.result(c, a, e, n, r, t)) && l.push({
                  attribute: n,
                  value: a,
                  validator: i,
                  globalOptions: r,
                  attributes: e,
                  options: c,
                  error: s.call(s, a, c, n, e, r)
                });
              }
            }

            return l;
          },
          processValidationResults: function processValidationResults(e, t) {
            e = o.pruneEmptyErrors(e, t), e = o.expandMultipleErrors(e, t), e = o.convertErrorMessages(e, t);
            var r = t.format || "grouped";
            if ("function" != typeof o.formatters[r]) throw new Error(o.format("Unknown format %{format}", t));
            return e = o.formatters[r](e), o.isEmpty(e) ? void 0 : e;
          },
          async: function async(e, t, r) {
            var n = (r = o.extend({}, o.async.options, r)).wrapErrors || function (e) {
              return e;
            };

            !1 !== r.cleanAttributes && (e = o.cleanAttributes(e, t));
            var i = o.runValidations(e, t, r);
            return new o.Promise(function (a, u) {
              o.waitForResults(i).then(function () {
                var s = o.processValidationResults(i, r);
                s ? u(new n(s, r, e, t)) : a(e);
              }, function (e) {
                u(e);
              });
            });
          },
          single: function single(e, t, r) {
            return r = o.extend({}, o.single.options, r, {
              format: "flat",
              fullMessages: !1
            }), o({
              single: e
            }, {
              single: t
            }, r);
          },
          waitForResults: function waitForResults(e) {
            return e.reduce(function (e, t) {
              return o.isPromise(t.error) ? e.then(function () {
                return t.error.then(function (e) {
                  t.error = e || null;
                });
              }) : e;
            }, new o.Promise(function (e) {
              e();
            }));
          },
          result: function result(e) {
            var t = [].slice.call(arguments, 1);
            return "function" == typeof e && (e = e.apply(null, t)), e;
          },
          isNumber: function isNumber(e) {
            return "number" == typeof e && !isNaN(e);
          },
          isFunction: function isFunction(e) {
            return "function" == typeof e;
          },
          isInteger: function isInteger(e) {
            return o.isNumber(e) && e % 1 == 0;
          },
          isBoolean: function isBoolean(e) {
            return "boolean" == typeof e;
          },
          isObject: function isObject(e) {
            return e === Object(e);
          },
          isDate: function isDate(e) {
            return e instanceof Date;
          },
          isDefined: function isDefined(e) {
            return null !== e && void 0 !== e;
          },
          isPromise: function isPromise(e) {
            return !!e && o.isFunction(e.then);
          },
          isJqueryElement: function isJqueryElement(e) {
            return e && o.isString(e.jquery);
          },
          isDomElement: function isDomElement(e) {
            return !!e && !(!e.querySelectorAll || !e.querySelector) && (!(!o.isObject(document) || e !== document) || ("object" == typeof HTMLElement ? e instanceof HTMLElement : e && "object" == typeof e && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName));
          },
          isEmpty: function isEmpty(e) {
            var t;
            if (!o.isDefined(e)) return !0;
            if (o.isFunction(e)) return !1;
            if (o.isString(e)) return o.EMPTY_STRING_REGEXP.test(e);
            if (o.isArray(e)) return 0 === e.length;
            if (o.isDate(e)) return !1;

            if (o.isObject(e)) {
              for (t in e) {
                return !1;
              }

              return !0;
            }

            return !1;
          },
          format: o.extend(function (e, t) {
            return o.isString(e) ? e.replace(o.format.FORMAT_REGEXP, function (e, r, n) {
              return "%" === r ? "%{" + n + "}" : String(t[n]);
            }) : e;
          }, {
            FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
          }),
          prettify: function prettify(e) {
            return o.isNumber(e) ? 100 * e % 1 == 0 ? "" + e : parseFloat(Math.round(100 * e) / 100).toFixed(2) : o.isArray(e) ? e.map(function (e) {
              return o.prettify(e);
            }).join(", ") : o.isObject(e) ? e.toString() : (e = "" + e).replace(/([^\s])\.([^\s])/g, "$1 $2").replace(/\\+/g, "").replace(/[_-]/g, " ").replace(/([a-z])([A-Z])/g, function (e, t, r) {
              return t + " " + r.toLowerCase();
            }).toLowerCase();
          },
          stringifyValue: function stringifyValue(e, t) {
            return (t && t.prettify || o.prettify)(e);
          },
          isString: function isString(e) {
            return "string" == typeof e;
          },
          isArray: function isArray(e) {
            return "[object Array]" === {}.toString.call(e);
          },
          isHash: function isHash(e) {
            return o.isObject(e) && !o.isArray(e) && !o.isFunction(e);
          },
          contains: function contains(e, t) {
            return !!o.isDefined(e) && (o.isArray(e) ? -1 !== e.indexOf(t) : t in e);
          },
          unique: function unique(e) {
            return o.isArray(e) ? e.filter(function (e, t, r) {
              return r.indexOf(e) == t;
            }) : e;
          },
          forEachKeyInKeypath: function forEachKeyInKeypath(e, t, r) {
            if (o.isString(t)) {
              var n,
                  i = "",
                  a = !1;

              for (n = 0; n < t.length; ++n) {
                switch (t[n]) {
                  case ".":
                    a ? (a = !1, i += ".") : (e = r(e, i, !1), i = "");
                    break;

                  case "\\":
                    a ? (a = !1, i += "\\") : a = !0;
                    break;

                  default:
                    a = !1, i += t[n];
                }
              }

              return r(e, i, !0);
            }
          },
          getDeepObjectValue: function getDeepObjectValue(e, t) {
            if (o.isObject(e)) return o.forEachKeyInKeypath(e, t, function (e, t) {
              if (o.isObject(e)) return e[t];
            });
          },
          collectFormValues: function collectFormValues(e, t) {
            var r,
                n,
                i,
                a,
                u,
                s,
                c = {};
            if (o.isJqueryElement(e) && (e = e[0]), !e) return c;

            for (t = t || {}, a = e.querySelectorAll("input[name], textarea[name]"), r = 0; r < a.length; ++r) {
              i = a.item(r), o.isDefined(i.getAttribute("data-ignored")) || (name = i.name.replace(/\./g, "\\\\."), s = o.sanitizeFormValue(i.value, t), "number" === i.type ? s = s ? +s : null : "checkbox" === i.type ? i.attributes.value ? i.checked || (s = c[name] || null) : s = i.checked : "radio" === i.type && (i.checked || (s = c[name] || null)), c[name] = s);
            }

            for (a = e.querySelectorAll("select[name]"), r = 0; r < a.length; ++r) {
              if (i = a.item(r), !o.isDefined(i.getAttribute("data-ignored"))) {
                if (i.multiple) for (n in s = [], i.options) {
                  (u = i.options[n]) && u.selected && s.push(o.sanitizeFormValue(u.value, t));
                } else {
                  var f = void 0 !== i.options[i.selectedIndex] ? i.options[i.selectedIndex].value : "";
                  s = o.sanitizeFormValue(f, t);
                }
                c[i.name] = s;
              }
            }

            return c;
          },
          sanitizeFormValue: function sanitizeFormValue(e, t) {
            return t.trim && o.isString(e) && (e = e.trim()), !1 !== t.nullify && "" === e ? null : e;
          },
          capitalize: function capitalize(e) {
            return o.isString(e) ? e[0].toUpperCase() + e.slice(1) : e;
          },
          pruneEmptyErrors: function pruneEmptyErrors(e) {
            return e.filter(function (e) {
              return !o.isEmpty(e.error);
            });
          },
          expandMultipleErrors: function expandMultipleErrors(e) {
            var t = [];
            return e.forEach(function (e) {
              o.isArray(e.error) ? e.error.forEach(function (r) {
                t.push(o.extend({}, e, {
                  error: r
                }));
              }) : t.push(e);
            }), t;
          },
          convertErrorMessages: function convertErrorMessages(e, t) {
            var r = [],
                n = (t = t || {}).prettify || o.prettify;
            return e.forEach(function (e) {
              var i = o.result(e.error, e.value, e.attribute, e.options, e.attributes, e.globalOptions);
              o.isString(i) ? ("^" === i[0] ? i = i.slice(1) : !1 !== t.fullMessages && (i = o.capitalize(n(e.attribute)) + " " + i), i = i.replace(/\\\^/g, "^"), i = o.format(i, {
                value: o.stringifyValue(e.value, t)
              }), r.push(o.extend({}, e, {
                error: i
              }))) : r.push(e);
            }), r;
          },
          groupErrorsByAttribute: function groupErrorsByAttribute(e) {
            var t = {};
            return e.forEach(function (e) {
              var r = t[e.attribute];
              r ? r.push(e) : t[e.attribute] = [e];
            }), t;
          },
          flattenErrorsToArray: function flattenErrorsToArray(e) {
            return e.map(function (e) {
              return e.error;
            }).filter(function (e, t, r) {
              return r.indexOf(e) === t;
            });
          },
          cleanAttributes: function cleanAttributes(e, t) {
            function r(e, t, r) {
              return o.isObject(e[t]) ? e[t] : e[t] = !!r || {};
            }

            return o.isObject(t) && o.isObject(e) ? function e(t, r) {
              if (!o.isObject(t)) return t;
              var n,
                  i,
                  a = o.extend({}, t);

              for (i in t) {
                n = r[i], o.isObject(n) ? a[i] = e(a[i], n) : n || delete a[i];
              }

              return a;
            }(e, t = function (e) {
              var t,
                  n = {};

              for (t in e) {
                e[t] && o.forEachKeyInKeypath(n, t, r);
              }

              return n;
            }(t)) : {};
          },
          exposeModule: function exposeModule(e, t, r, n, i) {
            r ? (n && n.exports && (r = n.exports = e), r.validate = e) : (t.validate = e, e.isFunction(i) && i.amd && i([], function () {
              return e;
            }));
          },
          warn: function warn(e) {
            "undefined" != typeof console && console.warn && console.warn("[validate.js] " + e);
          },
          error: function error(e) {
            "undefined" != typeof console && console.error && console.error("[validate.js] " + e);
          }
        }), i.validators = {
          presence: function presence(e, t) {
            if (!1 !== (t = o.extend({}, this.options, t)).allowEmpty ? !o.isDefined(e) : o.isEmpty(e)) return t.message || this.message || "can't be blank";
          },
          length: function length(e, t, r) {
            if (o.isDefined(e)) {
              var n,
                  i = (t = o.extend({}, this.options, t)).is,
                  a = t.maximum,
                  u = t.minimum,
                  s = [],
                  c = (e = (t.tokenizer || function (e) {
                return e;
              })(e)).length;

              return o.isNumber(c) ? (o.isNumber(i) && c !== i && (n = t.wrongLength || this.wrongLength || "is the wrong length (should be %{count} characters)", s.push(o.format(n, {
                count: i
              }))), o.isNumber(u) && c < u && (n = t.tooShort || this.tooShort || "is too short (minimum is %{count} characters)", s.push(o.format(n, {
                count: u
              }))), o.isNumber(a) && c > a && (n = t.tooLong || this.tooLong || "is too long (maximum is %{count} characters)", s.push(o.format(n, {
                count: a
              }))), s.length > 0 ? t.message || s : void 0) : (o.error(o.format("Attribute %{attr} has a non numeric value for `length`", {
                attr: r
              })), t.message || this.notValid || "has an incorrect length");
            }
          },
          numericality: function numericality(e, t, r, n, i) {
            if (o.isDefined(e)) {
              var a,
                  u,
                  s = [],
                  c = {
                greaterThan: function greaterThan(e, t) {
                  return e > t;
                },
                greaterThanOrEqualTo: function greaterThanOrEqualTo(e, t) {
                  return e >= t;
                },
                equalTo: function equalTo(e, t) {
                  return e === t;
                },
                lessThan: function lessThan(e, t) {
                  return e < t;
                },
                lessThanOrEqualTo: function lessThanOrEqualTo(e, t) {
                  return e <= t;
                },
                divisibleBy: function divisibleBy(e, t) {
                  return e % t == 0;
                }
              },
                  f = (t = o.extend({}, this.options, t)).prettify || i && i.prettify || o.prettify;

              if (o.isString(e) && t.strict) {
                var l = "^-?(0|[1-9]\\d*)";
                if (t.onlyInteger || (l += "(\\.\\d+)?"), l += "$", !new RegExp(l).test(e)) return t.message || t.notValid || this.notValid || this.message || "must be a valid number";
              }

              if (!0 !== t.noStrings && o.isString(e) && !o.isEmpty(e) && (e = +e), !o.isNumber(e)) return t.message || t.notValid || this.notValid || this.message || "is not a number";
              if (t.onlyInteger && !o.isInteger(e)) return t.message || t.notInteger || this.notInteger || this.message || "must be an integer";

              for (a in c) {
                if (u = t[a], o.isNumber(u) && !c[a](e, u)) {
                  var p = "not" + o.capitalize(a),
                      d = t[p] || this[p] || this.message || "must be %{type} %{count}";
                  s.push(o.format(d, {
                    count: u,
                    type: f(a)
                  }));
                }
              }

              return t.odd && e % 2 != 1 && s.push(t.notOdd || this.notOdd || this.message || "must be odd"), t.even && e % 2 != 0 && s.push(t.notEven || this.notEven || this.message || "must be even"), s.length ? t.message || s : void 0;
            }
          },
          datetime: o.extend(function (e, t) {
            if (!o.isFunction(this.parse) || !o.isFunction(this.format)) throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");

            if (o.isDefined(e)) {
              var r,
                  n = [],
                  i = (t = o.extend({}, this.options, t)).earliest ? this.parse(t.earliest, t) : NaN,
                  a = t.latest ? this.parse(t.latest, t) : NaN;
              return e = this.parse(e, t), isNaN(e) || t.dateOnly && e % 864e5 != 0 ? (r = t.notValid || t.message || this.notValid || "must be a valid date", o.format(r, {
                value: arguments[0]
              })) : (!isNaN(i) && e < i && (r = t.tooEarly || t.message || this.tooEarly || "must be no earlier than %{date}", r = o.format(r, {
                value: this.format(e, t),
                date: this.format(i, t)
              }), n.push(r)), !isNaN(a) && e > a && (r = t.tooLate || t.message || this.tooLate || "must be no later than %{date}", r = o.format(r, {
                date: this.format(a, t),
                value: this.format(e, t)
              }), n.push(r)), n.length ? o.unique(n) : void 0);
            }
          }, {
            parse: null,
            format: null
          }),
          date: function date(e, t) {
            return t = o.extend({}, t, {
              dateOnly: !0
            }), o.validators.datetime.call(o.validators.datetime, e, t);
          },
          format: function format(e, t) {
            (o.isString(t) || t instanceof RegExp) && (t = {
              pattern: t
            });
            var r,
                n = (t = o.extend({}, this.options, t)).message || this.message || "is invalid",
                i = t.pattern;
            if (o.isDefined(e)) return o.isString(e) ? (o.isString(i) && (i = new RegExp(t.pattern, t.flags)), (r = i.exec(e)) && r[0].length == e.length ? void 0 : n) : n;
          },
          inclusion: function inclusion(e, t) {
            if (o.isDefined(e) && (o.isArray(t) && (t = {
              within: t
            }), t = o.extend({}, this.options, t), !o.contains(t.within, e))) {
              var r = t.message || this.message || "^%{value} is not included in the list";
              return o.format(r, {
                value: e
              });
            }
          },
          exclusion: function exclusion(e, t) {
            if (o.isDefined(e) && (o.isArray(t) && (t = {
              within: t
            }), t = o.extend({}, this.options, t), o.contains(t.within, e))) {
              var r = t.message || this.message || "^%{value} is restricted";
              return o.format(r, {
                value: e
              });
            }
          },
          email: o.extend(function (e, t) {
            var r = (t = o.extend({}, this.options, t)).message || this.message || "is not a valid email";
            if (o.isDefined(e)) return o.isString(e) && this.PATTERN.exec(e) ? void 0 : r;
          }, {
            PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
          }),
          equality: function equality(e, t, r, n, i) {
            if (o.isDefined(e)) {
              o.isString(t) && (t = {
                attribute: t
              });
              var a = (t = o.extend({}, this.options, t)).message || this.message || "is not equal to %{attribute}";
              if (o.isEmpty(t.attribute) || !o.isString(t.attribute)) throw new Error("The attribute must be a non empty string");

              var u = o.getDeepObjectValue(n, t.attribute),
                  s = t.comparator || function (e, t) {
                return e === t;
              },
                  c = t.prettify || i && i.prettify || o.prettify;

              return s(e, u, t, r, n) ? void 0 : o.format(a, {
                attribute: c(t.attribute)
              });
            }
          },
          url: function url(e, t) {
            if (o.isDefined(e)) {
              var r = (t = o.extend({}, this.options, t)).message || this.message || "is not a valid url",
                  n = t.schemes || this.schemes || ["http", "https"],
                  i = t.allowLocal || this.allowLocal || !1;
              if (!o.isString(e)) return r;
              var a = "^(?:(?:" + n.join("|") + ")://)(?:\\S+(?::\\S*)?@)?(?:",
                  u = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
              return i ? u += "?" : a += "(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})", a += "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + u + ")(?::\\d{2,5})?(?:[/?#]\\S*)?$", new RegExp(a, "i").exec(e) ? void 0 : r;
            }
          }
        }, i.formatters = {
          detailed: function detailed(e) {
            return e;
          },
          flat: o.flattenErrorsToArray,
          grouped: function grouped(e) {
            var t;

            for (t in e = o.groupErrorsByAttribute(e)) {
              e[t] = o.flattenErrorsToArray(e[t]);
            }

            return e;
          },
          constraint: function constraint(e) {
            var t;

            for (t in e = o.groupErrorsByAttribute(e)) {
              e[t] = e[t].map(function (e) {
                return e.validator;
              }).sort();
            }

            return e;
          }
        }, i.exposeModule(i, this, e, t, r(52));
      }).call(this, t, e, r(52));
    }).call(this, r(11)(e));
  }, function (e, t, r) {
    var n = r(105),
        i = r(3);

    e.exports = function (e) {
      return null == e ? [] : n(e, i(e));
    };
  }, function (e, t, r) {
    var n = r(24);

    e.exports = function (e, t) {
      return n(t, function (t) {
        return e[t];
      });
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = Array(e); ++r < e;) {
        n[r] = t(r);
      }

      return n;
    };
  }, function (e, t, r) {
    var n = r(5),
        i = r(2),
        o = "[object Arguments]";

    e.exports = function (e) {
      return i(e) && n(e) == o;
    };
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (r = window);
    }

    e.exports = r;
  }, function (e, t, r) {
    var n = r(7),
        i = Object.prototype,
        o = i.hasOwnProperty,
        a = i.toString,
        u = n ? n.toStringTag : void 0;

    e.exports = function (e) {
      var t = o.call(e, u),
          r = e[u];

      try {
        e[u] = void 0;
        var n = !0;
      } catch (e) {}

      var i = a.call(e);
      return n && (t ? e[u] = r : delete e[u]), i;
    };
  }, function (e, t) {
    var r = Object.prototype.toString;

    e.exports = function (e) {
      return r.call(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, r) {
    var n = r(5),
        i = r(27),
        o = r(2),
        a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, e.exports = function (e) {
      return o(e) && i(e.length) && !!a[n(e)];
    };
  }, function (e, t, r) {
    var n = r(58)(Object.keys, Object);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(115)(r(167));
    e.exports = n;
  }, function (e, t, r) {
    var n = r(14),
        i = r(13),
        o = r(3);

    e.exports = function (e) {
      return function (t, r, a) {
        var u = Object(t);

        if (!i(t)) {
          var s = n(r, 3);
          t = o(t), r = function r(e) {
            return s(u[e], e, u);
          };
        }

        var c = e(t, r, a);
        return c > -1 ? u[s ? t[c] : c] : void 0;
      };
    };
  }, function (e, t, r) {
    var n = r(117),
        i = r(158),
        o = r(68);

    e.exports = function (e) {
      var t = i(e);
      return 1 == t.length && t[0][2] ? o(t[0][0], t[0][1]) : function (r) {
        return r === e || n(r, e, t);
      };
    };
  }, function (e, t, r) {
    var n = r(32),
        i = r(60),
        o = 1,
        a = 2;

    e.exports = function (e, t, r, u) {
      var s = r.length,
          c = s,
          f = !u;
      if (null == e) return !c;

      for (e = Object(e); s--;) {
        var l = r[s];
        if (f && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
      }

      for (; ++s < c;) {
        var p = (l = r[s])[0],
            d = e[p],
            h = l[1];

        if (f && l[2]) {
          if (void 0 === d && !(p in e)) return !1;
        } else {
          var v = new n();
          if (u) var g = u(d, h, p, e, t, v);
          if (!(void 0 === g ? i(h, d, o | a, u, v) : g)) return !1;
        }
      }

      return !0;
    };
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, r) {
    var n = r(16),
        i = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          r = n(t, e);
      return !(r < 0 || (r == t.length - 1 ? t.pop() : i.call(t, r, 1), --this.size, 0));
    };
  }, function (e, t, r) {
    var n = r(16);

    e.exports = function (e) {
      var t = this.__data__,
          r = n(t, e);
      return r < 0 ? void 0 : t[r][1];
    };
  }, function (e, t, r) {
    var n = r(16);

    e.exports = function (e) {
      return n(this.__data__, e) > -1;
    };
  }, function (e, t, r) {
    var n = r(16);

    e.exports = function (e, t) {
      var r = this.__data__,
          i = n(r, e);
      return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
    };
  }, function (e, t, r) {
    var n = r(15);

    e.exports = function () {
      this.__data__ = new n(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
          r = t.delete(e);
      return this.size = t.size, r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, r) {
    var n = r(15),
        i = r(34),
        o = r(35),
        a = 200;

    e.exports = function (e, t) {
      var r = this.__data__;

      if (r instanceof n) {
        var u = r.__data__;
        if (!i || u.length < a - 1) return u.push([e, t]), this.size = ++r.size, this;
        r = this.__data__ = new o(u);
      }

      return r.set(e, t), this.size = r.size, this;
    };
  }, function (e, t, r) {
    var n = r(31),
        i = r(129),
        o = r(4),
        a = r(59),
        u = /^\[object .+?Constructor\]$/,
        s = Function.prototype,
        c = Object.prototype,
        f = s.toString,
        l = c.hasOwnProperty,
        p = RegExp("^" + f.call(l).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!o(e) || i(e)) && (n(e) ? p : u).test(a(e));
    };
  }, function (e, t, r) {
    var n,
        i = r(130),
        o = (n = /[^.]+$/.exec(i && i.keys && i.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";

    e.exports = function (e) {
      return !!o && o in e;
    };
  }, function (e, t, r) {
    var n = r(1)["__core-js_shared__"];
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, r) {
    var n = r(133),
        i = r(15),
        o = r(34);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new n(),
        map: new (o || i)(),
        string: new n()
      };
    };
  }, function (e, t, r) {
    function n(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    var i = r(134),
        o = r(135),
        a = r(136),
        u = r(137),
        s = r(138);
    n.prototype.clear = i, n.prototype.delete = o, n.prototype.get = a, n.prototype.has = u, n.prototype.set = s, e.exports = n;
  }, function (e, t, r) {
    var n = r(17);

    e.exports = function () {
      this.__data__ = n ? n(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, r) {
    var n = r(17),
        i = "__lodash_hash_undefined__",
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (n) {
        var r = t[e];
        return r === i ? void 0 : r;
      }

      return o.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, r) {
    var n = r(17),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return n ? void 0 !== t[e] : i.call(t, e);
    };
  }, function (e, t, r) {
    var n = r(17),
        i = "__lodash_hash_undefined__";

    e.exports = function (e, t) {
      var r = this.__data__;
      return this.size += this.has(e) ? 0 : 1, r[e] = n && void 0 === t ? i : t, this;
    };
  }, function (e, t, r) {
    var n = r(18);

    e.exports = function (e) {
      var t = n(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, r) {
    var n = r(18);

    e.exports = function (e) {
      return n(this, e).get(e);
    };
  }, function (e, t, r) {
    var n = r(18);

    e.exports = function (e) {
      return n(this, e).has(e);
    };
  }, function (e, t, r) {
    var n = r(18);

    e.exports = function (e, t) {
      var r = n(this, e),
          i = r.size;
      return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
    };
  }, function (e, t, r) {
    var n = r(32),
        i = r(61),
        o = r(150),
        a = r(153),
        u = r(9),
        s = r(0),
        c = r(26),
        f = r(56),
        l = 1,
        p = "[object Arguments]",
        d = "[object Array]",
        h = "[object Object]",
        v = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r, g, m, y) {
      var b = s(e),
          x = s(t),
          w = b ? d : u(e),
          R = x ? d : u(t),
          _ = (w = w == p ? h : w) == h,
          j = (R = R == p ? h : R) == h,
          O = w == R;

      if (O && c(e)) {
        if (!c(t)) return !1;
        b = !0, _ = !1;
      }

      if (O && !_) return y || (y = new n()), b || f(e) ? i(e, t, r, g, m, y) : o(e, t, w, r, g, m, y);

      if (!(r & l)) {
        var S = _ && v.call(e, "__wrapped__"),
            k = j && v.call(t, "__wrapped__");

        if (S || k) {
          var F = S ? e.value() : e,
              P = k ? t.value() : t;
          return y || (y = new n()), m(F, P, r, g, y);
        }
      }

      return !!O && (y || (y = new n()), a(e, t, r, g, m, y));
    };
  }, function (e, t, r) {
    function n(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.__data__ = new i(); ++t < r;) {
        this.add(e[t]);
      }
    }

    var i = r(35),
        o = r(146),
        a = r(147);
    n.prototype.add = n.prototype.push = o, n.prototype.has = a, e.exports = n;
  }, function (e, t) {
    var r = "__lodash_hash_undefined__";

    e.exports = function (e) {
      return this.__data__.set(e, r), this;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
        if (t(e[r], r, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e.has(t);
    };
  }, function (e, t, r) {
    var n = r(7),
        i = r(62),
        o = r(33),
        a = r(61),
        u = r(151),
        s = r(152),
        c = 1,
        f = 2,
        l = "[object Boolean]",
        p = "[object Date]",
        d = "[object Error]",
        h = "[object Map]",
        v = "[object Number]",
        g = "[object RegExp]",
        m = "[object Set]",
        y = "[object String]",
        b = "[object Symbol]",
        x = "[object ArrayBuffer]",
        w = "[object DataView]",
        R = n ? n.prototype : void 0,
        _ = R ? R.valueOf : void 0;

    e.exports = function (e, t, r, n, R, j, O) {
      switch (r) {
        case w:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case x:
          return !(e.byteLength != t.byteLength || !j(new i(e), new i(t)));

        case l:
        case p:
        case v:
          return o(+e, +t);

        case d:
          return e.name == t.name && e.message == t.message;

        case g:
        case y:
          return e == t + "";

        case h:
          var S = u;

        case m:
          var k = n & c;
          if (S || (S = s), e.size != t.size && !k) return !1;
          var F = O.get(e);
          if (F) return F == t;
          n |= f, O.set(e, t);
          var P = a(S(e), S(t), n, R, j, O);
          return O.delete(e), P;

        case b:
          if (_) return _.call(e) == _.call(t);
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          r = Array(e.size);
      return e.forEach(function (e, n) {
        r[++t] = [n, e];
      }), r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          r = Array(e.size);
      return e.forEach(function (e) {
        r[++t] = e;
      }), r;
    };
  }, function (e, t, r) {
    var n = r(63),
        i = 1,
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r, a, u, s) {
      var c = r & i,
          f = n(e),
          l = f.length;
      if (l != n(t).length && !c) return !1;

      for (var p = l; p--;) {
        var d = f[p];
        if (!(c ? d in t : o.call(t, d))) return !1;
      }

      var h = s.get(e);
      if (h && s.get(t)) return h == t;
      var v = !0;
      s.set(e, t), s.set(t, e);

      for (var g = c; ++p < l;) {
        var m = e[d = f[p]],
            y = t[d];
        if (a) var b = c ? a(y, m, d, t, e, s) : a(m, y, d, e, t, s);

        if (!(void 0 === b ? m === y || u(m, y, r, a, s) : b)) {
          v = !1;
          break;
        }

        g || (g = "constructor" == d);
      }

      if (v && !g) {
        var x = e.constructor,
            w = t.constructor;
        x != w && "constructor" in e && "constructor" in t && !("function" == typeof x && x instanceof x && "function" == typeof w && w instanceof w) && (v = !1);
      }

      return s.delete(e), s.delete(t), v;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length, i = 0, o = []; ++r < n;) {
        var a = e[r];
        t(a, r, e) && (o[i++] = a);
      }

      return o;
    };
  }, function (e, t, r) {
    var n = r(6)(r(1), "DataView");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(6)(r(1), "Promise");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(6)(r(1), "Set");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(67),
        i = r(3);

    e.exports = function (e) {
      for (var t = i(e), r = t.length; r--;) {
        var o = t[r],
            a = e[o];
        t[r] = [o, a, n(a)];
      }

      return t;
    };
  }, function (e, t, r) {
    var n = r(60),
        i = r(69),
        o = r(73),
        a = r(39),
        u = r(67),
        s = r(68),
        c = r(8),
        f = 1,
        l = 2;

    e.exports = function (e, t) {
      return a(e) && u(t) ? s(c(e), t) : function (r) {
        var a = i(r, e);
        return void 0 === a && a === t ? o(r, e) : n(t, a, f | l);
      };
    };
  }, function (e, t, r) {
    var n = r(71),
        i = 500;

    e.exports = function (e) {
      var t = n(e, function (e) {
        return r.size === i && r.clear(), e;
      }),
          r = t.cache;
      return t;
    };
  }, function (e, t, r) {
    var n = r(7),
        i = r(24),
        o = r(0),
        a = r(10),
        u = 1 / 0,
        s = n ? n.prototype : void 0,
        c = s ? s.toString : void 0;

    e.exports = function e(t) {
      if ("string" == typeof t) return t;
      if (o(t)) return i(t, e) + "";
      if (a(t)) return c ? c.call(t) : "";
      var r = t + "";
      return "0" == r && 1 / t == -u ? "-0" : r;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return null != e && t in Object(e);
    };
  }, function (e, t, r) {
    var n = r(19),
        i = r(25),
        o = r(0),
        a = r(12),
        u = r(27),
        s = r(8);

    e.exports = function (e, t, r) {
      for (var c = -1, f = (t = n(t, e)).length, l = !1; ++c < f;) {
        var p = s(t[c]);
        if (!(l = null != e && r(e, p))) break;
        e = e[p];
      }

      return l || ++c != f ? l : !!(f = null == e ? 0 : e.length) && u(f) && a(p, f) && (o(e) || i(e));
    };
  }, function (e, t, r) {
    var n = r(165),
        i = r(166),
        o = r(39),
        a = r(8);

    e.exports = function (e) {
      return o(e) ? n(a(e)) : i(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
  }, function (e, t, r) {
    var n = r(38);

    e.exports = function (e) {
      return function (t) {
        return n(t, e);
      };
    };
  }, function (e, t, r) {
    var n = r(74),
        i = r(14),
        o = r(41),
        a = Math.max;

    e.exports = function (e, t, r) {
      var u = null == e ? 0 : e.length;
      if (!u) return -1;
      var s = null == r ? 0 : o(r);
      return s < 0 && (s = a(u + s, 0)), n(e, i(t, 3), s);
    };
  }, function (e, t, r) {
    var n = r(169),
        i = 1 / 0,
        o = 1.7976931348623157e308;

    e.exports = function (e) {
      return e ? (e = n(e)) === i || e === -i ? (e < 0 ? -1 : 1) * o : e == e ? e : 0 : 0 === e ? e : 0;
    };
  }, function (e, t, r) {
    var n = r(4),
        i = r(10),
        o = NaN,
        a = /^\s+|\s+$/g,
        u = /^[-+]0x[0-9a-f]+$/i,
        s = /^0b[01]+$/i,
        c = /^0o[0-7]+$/i,
        f = parseInt;

    e.exports = function (e) {
      if ("number" == typeof e) return e;
      if (i(e)) return o;

      if (n(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = n(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(a, "");
      var r = s.test(e);
      return r || c.test(e) ? f(e.slice(2), r ? 2 : 8) : u.test(e) ? o : +e;
    };
  }, function (e, t, r) {
    var n = r(75);

    e.exports = function (e, t, r) {
      return null == e ? e : n(e, t, r);
    };
  }, function (e, t, r) {
    var n = r(172),
        i = r(174);

    e.exports = function (e, t, r) {
      return n(i, e, t, r);
    };
  }, function (e, t, r) {
    function n(e, t) {
      return 2 == t ? function (t, r) {
        return e(t, r);
      } : function (t) {
        return e(t);
      };
    }

    function i(e) {
      for (var t = e ? e.length : 0, r = Array(t); t--;) {
        r[t] = e[t];
      }

      return r;
    }

    function o(e, t) {
      return function () {
        var r = arguments.length;

        if (r) {
          for (var n = Array(r); r--;) {
            n[r] = arguments[r];
          }

          var i = n[0] = t.apply(void 0, n);
          return e.apply(void 0, n), i;
        }
      };
    }

    var a = r(173),
        u = r(79),
        s = Array.prototype.push;

    e.exports = function e(t, r, c, f) {
      function l(e, t) {
        if (w.cap) {
          var r = a.iterateeRearg[e];
          if (r) return function (e, t) {
            return g(e, function (e) {
              var r = t.length;
              return function (e, t) {
                return 2 == t ? function (t, r) {
                  return e.apply(void 0, arguments);
                } : function (t) {
                  return e.apply(void 0, arguments);
                };
              }(B(n(e, r), t), r);
            });
          }(t, r);
          var i = !b && a.iterateeAry[e];
          if (i) return function (e, t) {
            return g(e, function (e) {
              return "function" == typeof e ? n(e, t) : e;
            });
          }(t, i);
        }

        return t;
      }

      function p(e, t, r) {
        if (w.fixed && (_ || !a.skipFixed[e])) {
          var n = a.methodSpread[e],
              i = n && n.start;
          return void 0 === i ? F(t, r) : function (e, t) {
            return function () {
              for (var r = arguments.length, n = r - 1, i = Array(r); r--;) {
                i[r] = arguments[r];
              }

              var o = i[t],
                  a = i.slice(0, t);
              return o && s.apply(a, o), t != n && s.apply(a, i.slice(t + 1)), e.apply(this, a);
            };
          }(t, i);
        }

        return t;
      }

      function d(e, t, r) {
        return w.rearg && r > 1 && (j || !a.skipRearg[e]) ? B(t, a.methodRearg[e] || a.aryRearg[r]) : t;
      }

      function h(e, t) {
        for (var r = -1, n = (t = W(t)).length, i = n - 1, o = A(Object(e)), a = o; null != a && ++r < n;) {
          var u = t[r],
              s = a[u];
          null == s || C(s) || L(s) || M(s) || (a[u] = A(r == i ? s : Object(s))), a = a[u];
        }

        return o;
      }

      function v(t, r) {
        var n = a.aliasToReal[t] || t,
            i = a.remap[n] || n,
            o = f;
        return function (t) {
          var a = b ? S : k,
              u = b ? S[i] : r,
              s = P(P({}, o), t);
          return e(a, n, u, s);
        };
      }

      function g(e, t) {
        return function () {
          var r = arguments.length;
          if (!r) return e();

          for (var n = Array(r); r--;) {
            n[r] = arguments[r];
          }

          var i = w.rearg ? 0 : r - 1;
          return n[i] = t(n[i]), e.apply(void 0, n);
        };
      }

      function m(e, t) {
        var r,
            n = a.aliasToReal[e] || e,
            u = t,
            s = z[n];
        return s ? u = s(t) : w.immutable && (a.mutate.array[n] ? u = o(t, i) : a.mutate.object[n] ? u = o(t, function (e) {
          return function (t) {
            return e({}, t);
          };
        }(t)) : a.mutate.set[n] && (u = o(t, h))), E(N, function (e) {
          return E(a.aryMethod[e], function (t) {
            if (n == t) {
              var i = a.methodSpread[n],
                  o = i && i.afterRearg;
              return r = o ? p(n, d(n, u, e), e) : d(n, p(n, u, e), e), r = l(n, r), s = r, c = e, r = R || w.curry && c > 1 ? I(s, c) : s, !1;
            }

            var s, c;
          }), !r;
        }), r || (r = u), r == t && (r = R ? I(r, 1) : function () {
          return t.apply(this, arguments);
        }), r.convert = v(n, t), a.placeholder[n] && (y = !0, r.placeholder = t.placeholder = O), r;
      }

      var y,
          b = "function" == typeof r,
          x = r === Object(r);
      if (x && (f = c, c = r, r = void 0), null == c) throw new TypeError();
      f || (f = {});

      var w = {
        cap: !("cap" in f) || f.cap,
        curry: !("curry" in f) || f.curry,
        fixed: !("fixed" in f) || f.fixed,
        immutable: !("immutable" in f) || f.immutable,
        rearg: !("rearg" in f) || f.rearg
      },
          R = "curry" in f && f.curry,
          _ = "fixed" in f && f.fixed,
          j = "rearg" in f && f.rearg,
          O = b ? c : u,
          S = b ? c.runInContext() : void 0,
          k = b ? c : {
        ary: t.ary,
        assign: t.assign,
        clone: t.clone,
        curry: t.curry,
        forEach: t.forEach,
        isArray: t.isArray,
        isError: t.isError,
        isFunction: t.isFunction,
        isWeakMap: t.isWeakMap,
        iteratee: t.iteratee,
        keys: t.keys,
        rearg: t.rearg,
        toInteger: t.toInteger,
        toPath: t.toPath
      },
          F = k.ary,
          P = k.assign,
          A = k.clone,
          I = k.curry,
          E = k.forEach,
          D = k.isArray,
          L = k.isError,
          C = k.isFunction,
          M = k.isWeakMap,
          T = k.keys,
          B = k.rearg,
          U = k.toInteger,
          W = k.toPath,
          N = T(a.aryMethod),
          z = {
        castArray: function castArray(e) {
          return function () {
            var t = arguments[0];
            return D(t) ? e(i(t)) : e.apply(void 0, arguments);
          };
        },
        iteratee: function iteratee(e) {
          return function () {
            var t = arguments[0],
                r = arguments[1],
                i = e(t, r),
                o = i.length;
            return w.cap && "number" == typeof r ? (r = r > 2 ? r - 2 : 1, o && o <= r ? i : n(i, r)) : i;
          };
        },
        mixin: function mixin(e) {
          return function (t) {
            var r = this;
            if (!C(r)) return e(r, Object(t));
            var n = [];
            return E(T(t), function (e) {
              C(t[e]) && n.push([e, r.prototype[e]]);
            }), e(r, Object(t)), E(n, function (e) {
              var t = e[1];
              C(t) ? r.prototype[e[0]] = t : delete r.prototype[e[0]];
            }), r;
          };
        },
        nthArg: function nthArg(e) {
          return function (t) {
            var r = t < 0 ? 1 : U(t) + 1;
            return I(e(t), r);
          };
        },
        rearg: function rearg(e) {
          return function (t, r) {
            var n = r ? r.length : 0;
            return I(e(t, r), n);
          };
        },
        runInContext: function runInContext(r) {
          return function (n) {
            return e(t, r(n), f);
          };
        }
      };

      if (!x) return m(r, c);
      var G = c,
          V = [];
      return E(N, function (e) {
        E(a.aryMethod[e], function (e) {
          var t = G[a.remap[e] || e];
          t && V.push([e, m(e, t)]);
        });
      }), E(T(G), function (e) {
        var t = G[e];

        if ("function" == typeof t) {
          for (var r = V.length; r--;) {
            if (V[r][0] == e) return;
          }

          t.convert = v(e, t), V.push([e, t]);
        }
      }), E(V, function (e) {
        G[e[0]] = e[1];
      }), G.convert = function (e) {
        return G.runInContext.convert(e)(void 0);
      }, y && (G.placeholder = O), E(T(G), function (e) {
        E(a.realToAlias[e] || [], function (t) {
          G[t] = G[e];
        });
      }), G;
    };
  }, function (e, t) {
    t.aliasToReal = {
      each: "forEach",
      eachRight: "forEachRight",
      entries: "toPairs",
      entriesIn: "toPairsIn",
      extend: "assignIn",
      extendAll: "assignInAll",
      extendAllWith: "assignInAllWith",
      extendWith: "assignInWith",
      first: "head",
      conforms: "conformsTo",
      matches: "isMatch",
      property: "get",
      __: "placeholder",
      F: "stubFalse",
      T: "stubTrue",
      all: "every",
      allPass: "overEvery",
      always: "constant",
      any: "some",
      anyPass: "overSome",
      apply: "spread",
      assoc: "set",
      assocPath: "set",
      complement: "negate",
      compose: "flowRight",
      contains: "includes",
      dissoc: "unset",
      dissocPath: "unset",
      dropLast: "dropRight",
      dropLastWhile: "dropRightWhile",
      equals: "isEqual",
      identical: "eq",
      indexBy: "keyBy",
      init: "initial",
      invertObj: "invert",
      juxt: "over",
      omitAll: "omit",
      nAry: "ary",
      path: "get",
      pathEq: "matchesProperty",
      pathOr: "getOr",
      paths: "at",
      pickAll: "pick",
      pipe: "flow",
      pluck: "map",
      prop: "get",
      propEq: "matchesProperty",
      propOr: "getOr",
      props: "at",
      symmetricDifference: "xor",
      symmetricDifferenceBy: "xorBy",
      symmetricDifferenceWith: "xorWith",
      takeLast: "takeRight",
      takeLastWhile: "takeRightWhile",
      unapply: "rest",
      unnest: "flatten",
      useWith: "overArgs",
      where: "conformsTo",
      whereEq: "isMatch",
      zipObj: "zipObject"
    }, t.aryMethod = {
      1: ["assignAll", "assignInAll", "attempt", "castArray", "ceil", "create", "curry", "curryRight", "defaultsAll", "defaultsDeepAll", "floor", "flow", "flowRight", "fromPairs", "invert", "iteratee", "memoize", "method", "mergeAll", "methodOf", "mixin", "nthArg", "over", "overEvery", "overSome", "rest", "reverse", "round", "runInContext", "spread", "template", "trim", "trimEnd", "trimStart", "uniqueId", "words", "zipAll"],
      2: ["add", "after", "ary", "assign", "assignAllWith", "assignIn", "assignInAllWith", "at", "before", "bind", "bindAll", "bindKey", "chunk", "cloneDeepWith", "cloneWith", "concat", "conformsTo", "countBy", "curryN", "curryRightN", "debounce", "defaults", "defaultsDeep", "defaultTo", "delay", "difference", "divide", "drop", "dropRight", "dropRightWhile", "dropWhile", "endsWith", "eq", "every", "filter", "find", "findIndex", "findKey", "findLast", "findLastIndex", "findLastKey", "flatMap", "flatMapDeep", "flattenDepth", "forEach", "forEachRight", "forIn", "forInRight", "forOwn", "forOwnRight", "get", "groupBy", "gt", "gte", "has", "hasIn", "includes", "indexOf", "intersection", "invertBy", "invoke", "invokeMap", "isEqual", "isMatch", "join", "keyBy", "lastIndexOf", "lt", "lte", "map", "mapKeys", "mapValues", "matchesProperty", "maxBy", "meanBy", "merge", "mergeAllWith", "minBy", "multiply", "nth", "omit", "omitBy", "overArgs", "pad", "padEnd", "padStart", "parseInt", "partial", "partialRight", "partition", "pick", "pickBy", "propertyOf", "pull", "pullAll", "pullAt", "random", "range", "rangeRight", "rearg", "reject", "remove", "repeat", "restFrom", "result", "sampleSize", "some", "sortBy", "sortedIndex", "sortedIndexOf", "sortedLastIndex", "sortedLastIndexOf", "sortedUniqBy", "split", "spreadFrom", "startsWith", "subtract", "sumBy", "take", "takeRight", "takeRightWhile", "takeWhile", "tap", "throttle", "thru", "times", "trimChars", "trimCharsEnd", "trimCharsStart", "truncate", "union", "uniqBy", "uniqWith", "unset", "unzipWith", "without", "wrap", "xor", "zip", "zipObject", "zipObjectDeep"],
      3: ["assignInWith", "assignWith", "clamp", "differenceBy", "differenceWith", "findFrom", "findIndexFrom", "findLastFrom", "findLastIndexFrom", "getOr", "includesFrom", "indexOfFrom", "inRange", "intersectionBy", "intersectionWith", "invokeArgs", "invokeArgsMap", "isEqualWith", "isMatchWith", "flatMapDepth", "lastIndexOfFrom", "mergeWith", "orderBy", "padChars", "padCharsEnd", "padCharsStart", "pullAllBy", "pullAllWith", "rangeStep", "rangeStepRight", "reduce", "reduceRight", "replace", "set", "slice", "sortedIndexBy", "sortedLastIndexBy", "transform", "unionBy", "unionWith", "update", "xorBy", "xorWith", "zipWith"],
      4: ["fill", "setWith", "updateWith"]
    }, t.aryRearg = {
      2: [1, 0],
      3: [2, 0, 1],
      4: [3, 2, 0, 1]
    }, t.iterateeAry = {
      dropRightWhile: 1,
      dropWhile: 1,
      every: 1,
      filter: 1,
      find: 1,
      findFrom: 1,
      findIndex: 1,
      findIndexFrom: 1,
      findKey: 1,
      findLast: 1,
      findLastFrom: 1,
      findLastIndex: 1,
      findLastIndexFrom: 1,
      findLastKey: 1,
      flatMap: 1,
      flatMapDeep: 1,
      flatMapDepth: 1,
      forEach: 1,
      forEachRight: 1,
      forIn: 1,
      forInRight: 1,
      forOwn: 1,
      forOwnRight: 1,
      map: 1,
      mapKeys: 1,
      mapValues: 1,
      partition: 1,
      reduce: 2,
      reduceRight: 2,
      reject: 1,
      remove: 1,
      some: 1,
      takeRightWhile: 1,
      takeWhile: 1,
      times: 1,
      transform: 2
    }, t.iterateeRearg = {
      mapKeys: [1],
      reduceRight: [1, 0]
    }, t.methodRearg = {
      assignInAllWith: [1, 0],
      assignInWith: [1, 2, 0],
      assignAllWith: [1, 0],
      assignWith: [1, 2, 0],
      differenceBy: [1, 2, 0],
      differenceWith: [1, 2, 0],
      getOr: [2, 1, 0],
      intersectionBy: [1, 2, 0],
      intersectionWith: [1, 2, 0],
      isEqualWith: [1, 2, 0],
      isMatchWith: [2, 1, 0],
      mergeAllWith: [1, 0],
      mergeWith: [1, 2, 0],
      padChars: [2, 1, 0],
      padCharsEnd: [2, 1, 0],
      padCharsStart: [2, 1, 0],
      pullAllBy: [2, 1, 0],
      pullAllWith: [2, 1, 0],
      rangeStep: [1, 2, 0],
      rangeStepRight: [1, 2, 0],
      setWith: [3, 1, 2, 0],
      sortedIndexBy: [2, 1, 0],
      sortedLastIndexBy: [2, 1, 0],
      unionBy: [1, 2, 0],
      unionWith: [1, 2, 0],
      updateWith: [3, 1, 2, 0],
      xorBy: [1, 2, 0],
      xorWith: [1, 2, 0],
      zipWith: [1, 2, 0]
    }, t.methodSpread = {
      assignAll: {
        start: 0
      },
      assignAllWith: {
        start: 0
      },
      assignInAll: {
        start: 0
      },
      assignInAllWith: {
        start: 0
      },
      defaultsAll: {
        start: 0
      },
      defaultsDeepAll: {
        start: 0
      },
      invokeArgs: {
        start: 2
      },
      invokeArgsMap: {
        start: 2
      },
      mergeAll: {
        start: 0
      },
      mergeAllWith: {
        start: 0
      },
      partial: {
        start: 1
      },
      partialRight: {
        start: 1
      },
      without: {
        start: 1
      },
      zipAll: {
        start: 0
      }
    }, t.mutate = {
      array: {
        fill: !0,
        pull: !0,
        pullAll: !0,
        pullAllBy: !0,
        pullAllWith: !0,
        pullAt: !0,
        remove: !0,
        reverse: !0
      },
      object: {
        assign: !0,
        assignAll: !0,
        assignAllWith: !0,
        assignIn: !0,
        assignInAll: !0,
        assignInAllWith: !0,
        assignInWith: !0,
        assignWith: !0,
        defaults: !0,
        defaultsAll: !0,
        defaultsDeep: !0,
        defaultsDeepAll: !0,
        merge: !0,
        mergeAll: !0,
        mergeAllWith: !0,
        mergeWith: !0
      },
      set: {
        set: !0,
        setWith: !0,
        unset: !0,
        update: !0,
        updateWith: !0
      }
    }, t.placeholder = {
      bind: !0,
      bindKey: !0,
      curry: !0,
      curryRight: !0,
      partial: !0,
      partialRight: !0
    }, t.realToAlias = function () {
      var e = Object.prototype.hasOwnProperty,
          r = t.aliasToReal,
          n = {};

      for (var i in r) {
        var o = r[i];
        e.call(n, o) ? n[o].push(i) : n[o] = [i];
      }

      return n;
    }(), t.remap = {
      assignAll: "assign",
      assignAllWith: "assignWith",
      assignInAll: "assignIn",
      assignInAllWith: "assignInWith",
      curryN: "curry",
      curryRightN: "curryRight",
      defaultsAll: "defaults",
      defaultsDeepAll: "defaultsDeep",
      findFrom: "find",
      findIndexFrom: "findIndex",
      findLastFrom: "findLast",
      findLastIndexFrom: "findLastIndex",
      getOr: "get",
      includesFrom: "includes",
      indexOfFrom: "indexOf",
      invokeArgs: "invoke",
      invokeArgsMap: "invokeMap",
      lastIndexOfFrom: "lastIndexOf",
      mergeAll: "merge",
      mergeAllWith: "mergeWith",
      padChars: "pad",
      padCharsEnd: "padEnd",
      padCharsStart: "padStart",
      propertyOf: "get",
      rangeStep: "range",
      rangeStepRight: "rangeRight",
      restFrom: "rest",
      spreadFrom: "spread",
      trimChars: "trim",
      trimCharsEnd: "trimEnd",
      trimCharsStart: "trimStart",
      zipAll: "zip"
    }, t.skipFixed = {
      castArray: !0,
      flow: !0,
      flowRight: !0,
      iteratee: !0,
      mixin: !0,
      rearg: !0,
      runInContext: !0
    }, t.skipRearg = {
      add: !0,
      assign: !0,
      assignIn: !0,
      bind: !0,
      bindKey: !0,
      concat: !0,
      difference: !0,
      divide: !0,
      eq: !0,
      gt: !0,
      gte: !0,
      isEqual: !0,
      lt: !0,
      lte: !0,
      matchesProperty: !0,
      merge: !0,
      multiply: !0,
      overArgs: !0,
      partial: !0,
      partialRight: !0,
      propertyOf: !0,
      random: !0,
      range: !0,
      rangeRight: !0,
      subtract: !0,
      zip: !0,
      zipObject: !0,
      zipObjectDeep: !0
    };
  }, function (e, t, r) {
    e.exports = {
      ary: r(175),
      assign: r(93),
      clone: r(197),
      curry: r(96),
      forEach: r(47),
      isArray: r(0),
      isError: r(216),
      isFunction: r(31),
      isWeakMap: r(217),
      iteratee: r(218),
      keys: r(57),
      rearg: r(219),
      toInteger: r(41),
      toPath: r(224)
    };
  }, function (e, t, r) {
    var n = r(43),
        i = 128;

    e.exports = function (e, t, r) {
      return t = r ? void 0 : t, t = e && null == t ? e.length : t, n(e, i, void 0, void 0, void 0, void 0, t);
    };
  }, function (e, t, r) {
    var n = r(20),
        i = r(1),
        o = 1;

    e.exports = function (e, t, r) {
      var a = t & o,
          u = n(e);
      return function t() {
        return (this && this !== i && this instanceof t ? u : e).apply(a ? r : this, arguments);
      };
    };
  }, function (e, t, r) {
    var n = r(44),
        i = r(20),
        o = r(82),
        a = r(85),
        u = r(92),
        s = r(48),
        c = r(1);

    e.exports = function (e, t, r) {
      var f = i(e);
      return function i() {
        for (var l = arguments.length, p = Array(l), d = l, h = u(i); d--;) {
          p[d] = arguments[d];
        }

        var v = l < 3 && p[0] !== h && p[l - 1] !== h ? [] : s(p, h);
        return (l -= v.length) < r ? a(e, t, o, i.placeholder, void 0, p, v, void 0, void 0, r - l) : n(this && this !== c && this instanceof i ? f : e, this, p);
      };
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = e.length, n = 0; r--;) {
        e[r] === t && ++n;
      }

      return n;
    };
  }, function (e, t, r) {
    var n = r(45),
        i = r(86),
        o = r(181),
        a = r(183);

    e.exports = function (e) {
      var t = o(e),
          r = a[t];
      if ("function" != typeof r || !(t in n.prototype)) return !1;
      if (e === r) return !0;
      var u = i(r);
      return !!u && e === u[0];
    };
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t, r) {
    var n = r(182),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      for (var t = e.name + "", r = n[t], o = i.call(n, t) ? r.length : 0; o--;) {
        var a = r[o],
            u = a.func;
        if (null == u || u == e) return a.name;
      }

      return t;
    };
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, r) {
    function n(e) {
      if (s(e) && !u(e) && !(e instanceof i)) {
        if (e instanceof o) return e;
        if (f.call(e, "__wrapped__")) return c(e);
      }

      return new o(e);
    }

    var i = r(45),
        o = r(87),
        a = r(46),
        u = r(0),
        s = r(2),
        c = r(184),
        f = Object.prototype.hasOwnProperty;
    n.prototype = a.prototype, n.prototype.constructor = n, e.exports = n;
  }, function (e, t, r) {
    var n = r(45),
        i = r(87),
        o = r(22);

    e.exports = function (e) {
      if (e instanceof n) return e.clone();
      var t = new i(e.__wrapped__, e.__chain__);
      return t.__actions__ = o(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
    };
  }, function (e, t) {
    var r = /\{\n\/\* \[wrapped with (.+)\] \*/,
        n = /,? & /;

    e.exports = function (e) {
      var t = e.match(r);
      return t ? t[1].split(n) : [];
    };
  }, function (e, t) {
    var r = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

    e.exports = function (e, t) {
      var n = t.length;
      if (!n) return e;
      var i = n - 1;
      return t[i] = (n > 1 ? "& " : "") + t[i], t = t.join(n > 2 ? ", " : " "), e.replace(r, "{\n/* [wrapped with " + t + "] */\n");
    };
  }, function (e, t, r) {
    var n = r(188),
        i = r(77),
        o = r(40),
        a = i ? function (e, t) {
      return i(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: n(t),
        writable: !0
      });
    } : o;
    e.exports = a;
  }, function (e, t) {
    e.exports = function (e) {
      return function () {
        return e;
      };
    };
  }, function (e, t, r) {
    var n = r(47),
        i = r(190),
        o = [["ary", 128], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", 16], ["flip", 512], ["partial", 32], ["partialRight", 64], ["rearg", 256]];

    e.exports = function (e, t) {
      return n(o, function (r) {
        var n = "_." + r[0];
        t & r[1] && !i(e, n) && e.push(n);
      }), e.sort();
    };
  }, function (e, t, r) {
    var n = r(191);

    e.exports = function (e, t) {
      return !(null == e || !e.length) && n(e, t, 0) > -1;
    };
  }, function (e, t, r) {
    var n = r(74),
        i = r(192),
        o = r(193);

    e.exports = function (e, t, r) {
      return t == t ? o(e, t, r) : n(e, i, r);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e != e;
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      for (var n = r - 1, i = e.length; ++n < i;) {
        if (e[n] === t) return n;
      }

      return -1;
    };
  }, function (e, t, r) {
    var n = r(22),
        i = r(12),
        o = Math.min;

    e.exports = function (e, t) {
      for (var r = e.length, a = o(t.length, r), u = n(e); a--;) {
        var s = t[a];
        e[a] = i(s, r) ? u[s] : void 0;
      }

      return e;
    };
  }, function (e, t, r) {
    var n = r(44),
        i = r(20),
        o = r(1),
        a = 1;

    e.exports = function (e, t, r, u) {
      var s = t & a,
          c = i(e);
      return function t() {
        for (var i = -1, a = arguments.length, f = -1, l = u.length, p = Array(l + a), d = this && this !== o && this instanceof t ? c : e; ++f < l;) {
          p[f] = u[f];
        }

        for (; a--;) {
          p[f++] = arguments[++i];
        }

        return n(d, s ? r : this, p);
      };
    };
  }, function (e, t, r) {
    var n = r(83),
        i = r(84),
        o = r(48),
        a = "__lodash_placeholder__",
        u = 1,
        s = 2,
        c = 4,
        f = 8,
        l = 128,
        p = 256,
        d = Math.min;

    e.exports = function (e, t) {
      var r = e[1],
          h = t[1],
          v = r | h,
          g = v < (u | s | l),
          m = h == l && r == f || h == l && r == p && e[7].length <= t[8] || h == (l | p) && t[7].length <= t[8] && r == f;
      if (!g && !m) return e;
      h & u && (e[2] = t[2], v |= r & u ? 0 : c);
      var y = t[3];

      if (y) {
        var b = e[3];
        e[3] = b ? n(b, y, t[4]) : y, e[4] = b ? o(e[3], a) : t[4];
      }

      return (y = t[5]) && (b = e[5], e[5] = b ? i(b, y, t[6]) : y, e[6] = b ? o(e[5], a) : t[6]), (y = t[7]) && (e[7] = y), h & l && (e[8] = null == e[8] ? t[8] : d(e[8], t[8])), null == e[9] && (e[9] = t[9]), e[0] = t[0], e[1] = v, e;
    };
  }, function (e, t, r) {
    var n = r(49),
        i = 4;

    e.exports = function (e) {
      return n(e, i);
    };
  }, function (e, t, r) {
    var n = r(23),
        i = r(94);

    e.exports = function (e, t) {
      return e && n(t, i(t), e);
    };
  }, function (e, t, r) {
    var n = r(4),
        i = r(30),
        o = r(200),
        a = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!n(e)) return o(e);
      var t = i(e),
          r = [];

      for (var u in e) {
        ("constructor" != u || !t && a.call(e, u)) && r.push(u);
      }

      return r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var r in Object(e)) {
        t.push(r);
      }
      return t;
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(1),
          i = "object" == typeof t && t && !t.nodeType && t,
          o = i && "object" == typeof e && e && !e.nodeType && e,
          a = o && o.exports === i ? n.Buffer : void 0,
          u = a ? a.allocUnsafe : void 0;

      e.exports = function (e, t) {
        if (t) return e.slice();
        var r = e.length,
            n = u ? u(r) : new e.constructor(r);
        return e.copy(n), n;
      };
    }).call(this, r(11)(e));
  }, function (e, t, r) {
    var n = r(23),
        i = r(37);

    e.exports = function (e, t) {
      return n(e, i(e), t);
    };
  }, function (e, t, r) {
    var n = r(23),
        i = r(95);

    e.exports = function (e, t) {
      return n(e, i(e), t);
    };
  }, function (e, t, r) {
    var n = r(64),
        i = r(95),
        o = r(94);

    e.exports = function (e) {
      return n(e, o, i);
    };
  }, function (e, t) {
    var r = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = e.length,
          n = new e.constructor(t);
      return t && "string" == typeof e[0] && r.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    };
  }, function (e, t, r) {
    var n = r(51),
        i = r(207),
        o = r(208),
        a = r(209),
        u = r(210),
        s = "[object Boolean]",
        c = "[object Date]",
        f = "[object Map]",
        l = "[object Number]",
        p = "[object RegExp]",
        d = "[object Set]",
        h = "[object String]",
        v = "[object Symbol]",
        g = "[object ArrayBuffer]",
        m = "[object DataView]",
        y = "[object Float32Array]",
        b = "[object Float64Array]",
        x = "[object Int8Array]",
        w = "[object Int16Array]",
        R = "[object Int32Array]",
        _ = "[object Uint8Array]",
        j = "[object Uint8ClampedArray]",
        O = "[object Uint16Array]",
        S = "[object Uint32Array]";

    e.exports = function (e, t, r) {
      var k = e.constructor;

      switch (t) {
        case g:
          return n(e);

        case s:
        case c:
          return new k(+e);

        case m:
          return i(e, r);

        case y:
        case b:
        case x:
        case w:
        case R:
        case _:
        case j:
        case O:
        case S:
          return u(e, r);

        case f:
          return new k();

        case l:
        case h:
          return new k(e);

        case p:
          return o(e);

        case d:
          return new k();

        case v:
          return a(e);
      }
    };
  }, function (e, t, r) {
    var n = r(51);

    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.byteLength);
    };
  }, function (e, t) {
    var r = /\w*$/;

    e.exports = function (e) {
      var t = new e.constructor(e.source, r.exec(e));
      return t.lastIndex = e.lastIndex, t;
    };
  }, function (e, t, r) {
    var n = r(7),
        i = n ? n.prototype : void 0,
        o = i ? i.valueOf : void 0;

    e.exports = function (e) {
      return o ? Object(o.call(e)) : {};
    };
  }, function (e, t, r) {
    var n = r(51);

    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.length);
    };
  }, function (e, t, r) {
    var n = r(21),
        i = r(50),
        o = r(30);

    e.exports = function (e) {
      return "function" != typeof e.constructor || o(e) ? {} : n(i(e));
    };
  }, function (e, t, r) {
    var n = r(213),
        i = r(28),
        o = r(29),
        a = o && o.isMap,
        u = a ? i(a) : n;
    e.exports = u;
  }, function (e, t, r) {
    var n = r(9),
        i = r(2),
        o = "[object Map]";

    e.exports = function (e) {
      return i(e) && n(e) == o;
    };
  }, function (e, t, r) {
    var n = r(215),
        i = r(28),
        o = r(29),
        a = o && o.isSet,
        u = a ? i(a) : n;
    e.exports = u;
  }, function (e, t, r) {
    var n = r(9),
        i = r(2),
        o = "[object Set]";

    e.exports = function (e) {
      return i(e) && n(e) == o;
    };
  }, function (e, t, r) {
    var n = r(5),
        i = r(2),
        o = r(97),
        a = "[object DOMException]",
        u = "[object Error]";

    e.exports = function (e) {
      if (!i(e)) return !1;
      var t = n(e);
      return t == u || t == a || "string" == typeof e.message && "string" == typeof e.name && !o(e);
    };
  }, function (e, t, r) {
    var n = r(9),
        i = r(2),
        o = "[object WeakMap]";

    e.exports = function (e) {
      return i(e) && n(e) == o;
    };
  }, function (e, t, r) {
    var n = r(49),
        i = r(14),
        o = 1;

    e.exports = function (e) {
      return i("function" == typeof e ? e : n(e, o));
    };
  }, function (e, t, r) {
    var n = r(43),
        i = r(98)(function (e, t) {
      return n(e, 256, void 0, void 0, void 0, t);
    });
    e.exports = i;
  }, function (e, t, r) {
    var n = r(221);

    e.exports = function (e) {
      return null != e && e.length ? n(e, 1) : [];
    };
  }, function (e, t, r) {
    var n = r(36),
        i = r(222);

    e.exports = function e(t, r, o, a, u) {
      var s = -1,
          c = t.length;

      for (o || (o = i), u || (u = []); ++s < c;) {
        var f = t[s];
        r > 0 && o(f) ? r > 1 ? e(f, r - 1, o, a, u) : n(u, f) : a || (u[u.length] = f);
      }

      return u;
    };
  }, function (e, t, r) {
    var n = r(7),
        i = r(25),
        o = r(0),
        a = n ? n.isConcatSpreadable : void 0;

    e.exports = function (e) {
      return o(e) || i(e) || !!(a && e && e[a]);
    };
  }, function (e, t, r) {
    var n = r(44),
        i = Math.max;

    e.exports = function (e, t, r) {
      return t = i(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var o = arguments, a = -1, u = i(o.length - t, 0), s = Array(u); ++a < u;) {
          s[a] = o[t + a];
        }

        a = -1;

        for (var c = Array(t + 1); ++a < t;) {
          c[a] = o[a];
        }

        return c[t] = r(s), n(e, this, c);
      };
    };
  }, function (e, t, r) {
    var n = r(24),
        i = r(22),
        o = r(0),
        a = r(10),
        u = r(70),
        s = r(8),
        c = r(72);

    e.exports = function (e) {
      return o(e) ? n(e, s) : a(e) ? [e] : i(u(c(e)));
    };
  }, function (e, t, r) {
    var n = r(226),
        i = r(98)(function (e, t) {
      return null == e ? {} : n(e, t);
    });
    e.exports = i;
  }, function (e, t, r) {
    var n = r(227),
        i = r(73);

    e.exports = function (e, t) {
      return n(e, t, function (t, r) {
        return i(e, r);
      });
    };
  }, function (e, t, r) {
    var n = r(38),
        i = r(75),
        o = r(19);

    e.exports = function (e, t, r) {
      for (var a = -1, u = t.length, s = {}; ++a < u;) {
        var c = t[a],
            f = n(e, c);
        r(f, c) && i(s, o(c, e), f);
      }

      return s;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
          n = document.createElement("canvas");
      n.width = e.width, n.height = e.height;
      var o = n.getContext("2d");
      o.save(), function (e, t, r, n) {
        var i = e.width,
            o = e.style.width,
            a = e.height,
            u = e.style.height;
        r > 4 && (e.width = a, e.style.width = u, e.height = i, e.style.height = o);

        switch (r) {
          case 2:
            t.translate(i, 0), t.scale(-1, 1);
            break;

          case 3:
            t.translate(i, a), t.rotate(Math.PI);
            break;

          case 4:
            t.translate(0, a), t.scale(1, -1);
            break;

          case 5:
            t.rotate(.5 * Math.PI), t.scale(1, -1);
            break;

          case 6:
            t.rotate(.5 * Math.PI), t.translate(0, -a);
            break;

          case 7:
            t.rotate(.5 * Math.PI), t.translate(i, -a), t.scale(-1, 1);
            break;

          case 8:
            t.rotate(-.5 * Math.PI), t.translate(-i, 0);
        }

        t.drawImage(n, 0, 0), t.restore();
      }(n, o, r, e);

      for (var a = function (e, t) {
        var r = t.width / t.height,
            n = Math.min(t.width, e.maxWidth, r * e.maxHeight);
        e.maxSize > 0 && e.maxSize < t.width * t.height / 1e3 && (n = Math.min(n, Math.floor(1e3 * e.maxSize / t.height)));
        e.scaleRatio && (n = Math.min(n, Math.floor(e.scaleRatio * t.width)));
        e.debug && (console.log("browser-image-resizer: original image size = " + t.width + " px (width) X " + t.height + " px (height)"), console.log("browser-image-resizer: scaled image size = " + n + " px (width) X " + Math.floor(n / r) + " px (height)"));
        n <= 0 && (n = 1, console.warning("browser-image-resizer: image size is too small"));
        return n;
      }(t, n); n.width >= 2 * a;) {
        n = i(n);
      }

      n.width > a && (n = function (e, t) {
        var r = document.createElement("canvas"),
            n = t.outputWidth / e.width;
        r.width = e.width * n, r.height = e.height * n;
        var i = e.getContext("2d").getImageData(0, 0, e.width, e.height),
            o = r.getContext("2d").createImageData(r.width, r.height);
        return function (e, t, r) {
          function n(e, t, r, n, i, o) {
            var a = 1 - i,
                u = 1 - o;
            return e * a * u + t * i * u + r * a * o + n * i * o;
          }

          var i, o, a, u, s, c, f, l, p, d, h, v, g, m, y, b, x, w, R;

          for (i = 0; i < t.height; ++i) {
            for (a = i / r, u = Math.floor(a), s = Math.ceil(a) > e.height - 1 ? e.height - 1 : Math.ceil(a), o = 0; o < t.width; ++o) {
              c = o / r, f = Math.floor(c), l = Math.ceil(c) > e.width - 1 ? e.width - 1 : Math.ceil(c), p = 4 * (o + t.width * i), d = 4 * (f + e.width * u), h = 4 * (l + e.width * u), v = 4 * (f + e.width * s), g = 4 * (l + e.width * s), m = c - f, y = a - u, b = n(e.data[d], e.data[h], e.data[v], e.data[g], m, y), t.data[p] = b, x = n(e.data[d + 1], e.data[h + 1], e.data[v + 1], e.data[g + 1], m, y), t.data[p + 1] = x, w = n(e.data[d + 2], e.data[h + 2], e.data[v + 2], e.data[g + 2], m, y), t.data[p + 2] = w, R = n(e.data[d + 3], e.data[h + 3], e.data[v + 3], e.data[g + 3], m, y), t.data[p + 3] = R;
            }
          }
        }(i, o, n), r.getContext("2d").putImageData(o, 0, 0), r;
      }(n, Object.assign(t, {
        outputWidth: a
      })));
      var u = n.toDataURL("image/jpeg", t.quality);
      return "function" == typeof t.onScale && t.onScale(u), function (e) {
        for (var t = atob(e.split(",")[1]), r = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), i = new Uint8Array(n), o = 0; o < t.length; o++) {
          i[o] = t.charCodeAt(o);
        }

        return new Blob([n], {
          type: r
        });
      }(u);
    }

    function i(e) {
      var t = document.createElement("canvas");
      return t.width = e.width / 2, t.height = e.height / 2, t.getContext("2d").drawImage(e, 0, 0, t.width, t.height), t;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e, t) {
      return new Promise(function (r) {
        var i = document.createElement("img"),
            o = new FileReader(),
            a = Object.assign({}, s, t);
        o.onload = function (e) {
          i.src = e.target.result, i.onload = function () {
            a.autoRotate && (a.debug && console.log("browser-image-resizer: detecting image orientation..."), "function" == typeof u.default.getData && "function" == typeof u.default.getTag ? u.default.getData(i, function () {
              var e = u.default.getTag(this, "Orientation");
              a.debug && console.log("browser-image-resizer: image orientation from EXIF tag = " + e), r(n(i, a, e));
            }) : (console.error("browser-image-resizer: can't read EXIF data, the Exif.js library not found"), r(n(i, a))));
          };
        }, o.readAsDataURL(e);
      });
    }, t.scaleImage = n;
    var o,
        a = r(229),
        u = (o = a) && o.__esModule ? o : {
      default: o
    },
        s = {
      quality: .5,
      maxWidth: 800,
      maxHeight: 600,
      autoRotate: !0,
      debug: !1
    };
  }, function (e, t, r) {
    "use strict";

    var n,
        i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    (function () {
      function r(e) {
        return !!e.exifdata;
      }

      function o(e, t) {
        function r(r) {
          var n = a(r),
              i = function (e) {
            var t = new DataView(e);
            p && console.log("Got file of length " + e.byteLength);
            if (255 != t.getUint8(0) || 216 != t.getUint8(1)) return p && console.log("Not a valid JPEG"), !1;

            var r = 2,
                n = e.byteLength,
                i = function i(e, t) {
              return 56 === e.getUint8(t) && 66 === e.getUint8(t + 1) && 73 === e.getUint8(t + 2) && 77 === e.getUint8(t + 3) && 4 === e.getUint8(t + 4) && 4 === e.getUint8(t + 5);
            };

            for (; r < n;) {
              if (i(t, r)) {
                var o = t.getUint8(r + 7);
                o % 2 != 0 && (o += 1), 0 === o && (o = 4);
                var a = r + 8 + o,
                    s = t.getUint16(r + 6 + o);
                return u(e, a, s);
              }

              r++;
            }
          }(r);

          e.exifdata = n || {}, e.iptcdata = i || {}, t && t.call(e);
        }

        if (e.src) {
          if (/^data\:/i.test(e.src)) r(function (e, t) {
            t = t || e.match(/^data\:([^\;]+)\;base64,/im)[1] || "", e = e.replace(/^data\:([^\;]+)\;base64,/gim, "");

            for (var r = atob(e), n = r.length, i = new ArrayBuffer(n), o = new Uint8Array(i), a = 0; a < n; a++) {
              o[a] = r.charCodeAt(a);
            }

            return i;
          }(e.src));else if (/^blob\:/i.test(e.src)) {
            (i = new FileReader()).onload = function (e) {
              r(e.target.result);
            }, function (e, t) {
              var r = new XMLHttpRequest();
              r.open("GET", e, !0), r.responseType = "blob", r.onload = function (e) {
                200 != this.status && 0 !== this.status || t(this.response);
              }, r.send();
            }(e.src, function (e) {
              i.readAsArrayBuffer(e);
            });
          } else {
            var n = new XMLHttpRequest();
            n.onload = function () {
              if (200 != this.status && 0 !== this.status) throw "Could not load image";
              r(n.response), n = null;
            }, n.open("GET", e.src, !0), n.responseType = "arraybuffer", n.send(null);
          }
        } else if (self.FileReader && (e instanceof self.Blob || e instanceof self.File)) {
          var i;
          (i = new FileReader()).onload = function (e) {
            p && console.log("Got file of length " + e.target.result.byteLength), r(e.target.result);
          }, i.readAsArrayBuffer(e);
        }
      }

      function a(e) {
        var t = new DataView(e);
        if (p && console.log("Got file of length " + e.byteLength), 255 != t.getUint8(0) || 216 != t.getUint8(1)) return p && console.log("Not a valid JPEG"), !1;

        for (var r, n = 2, i = e.byteLength; n < i;) {
          if (255 != t.getUint8(n)) return p && console.log("Not a valid marker at offset " + n + ", found: " + t.getUint8(n)), !1;
          if (r = t.getUint8(n + 1), p && console.log(r), 225 == r) return p && console.log("Found 0xFFE1 marker"), l(t, n + 4, t.getUint16(n + 2));
          n += 2 + t.getUint16(n + 2);
        }
      }

      function u(e, t, r) {
        for (var n, i, o, a, u = new DataView(e), s = {}, c = t; c < t + r;) {
          28 === u.getUint8(c) && 2 === u.getUint8(c + 1) && (a = u.getUint8(c + 2)) in b && ((o = u.getInt16(c + 3)) + 5, i = b[a], n = f(u, c + 5, o), s.hasOwnProperty(i) ? s[i] instanceof Array ? s[i].push(n) : s[i] = [s[i], n] : s[i] = n), c++;
        }

        return s;
      }

      function s(e, t, r, n, i) {
        var o,
            a,
            u,
            s = e.getUint16(r, !i),
            f = {};

        for (u = 0; u < s; u++) {
          o = r + 12 * u + 2, !(a = n[e.getUint16(o, !i)]) && p && console.log("Unknown tag: " + e.getUint16(o, !i)), f[a] = c(e, o, t, r, i);
        }

        return f;
      }

      function c(e, t, r, n, i) {
        var o,
            a,
            u,
            s,
            c,
            l,
            p = e.getUint16(t + 2, !i),
            d = e.getUint32(t + 4, !i),
            h = e.getUint32(t + 8, !i) + r;

        switch (p) {
          case 1:
          case 7:
            if (1 == d) return e.getUint8(t + 8, !i);

            for (o = d > 4 ? h : t + 8, a = [], s = 0; s < d; s++) {
              a[s] = e.getUint8(o + s);
            }

            return a;

          case 2:
            return f(e, o = d > 4 ? h : t + 8, d - 1);

          case 3:
            if (1 == d) return e.getUint16(t + 8, !i);

            for (o = d > 2 ? h : t + 8, a = [], s = 0; s < d; s++) {
              a[s] = e.getUint16(o + 2 * s, !i);
            }

            return a;

          case 4:
            if (1 == d) return e.getUint32(t + 8, !i);

            for (a = [], s = 0; s < d; s++) {
              a[s] = e.getUint32(h + 4 * s, !i);
            }

            return a;

          case 5:
            if (1 == d) return c = e.getUint32(h, !i), l = e.getUint32(h + 4, !i), (u = new Number(c / l)).numerator = c, u.denominator = l, u;

            for (a = [], s = 0; s < d; s++) {
              c = e.getUint32(h + 8 * s, !i), l = e.getUint32(h + 4 + 8 * s, !i), a[s] = new Number(c / l), a[s].numerator = c, a[s].denominator = l;
            }

            return a;

          case 9:
            if (1 == d) return e.getInt32(t + 8, !i);

            for (a = [], s = 0; s < d; s++) {
              a[s] = e.getInt32(h + 4 * s, !i);
            }

            return a;

          case 10:
            if (1 == d) return e.getInt32(h, !i) / e.getInt32(h + 4, !i);

            for (a = [], s = 0; s < d; s++) {
              a[s] = e.getInt32(h + 8 * s, !i) / e.getInt32(h + 4 + 8 * s, !i);
            }

            return a;
        }
      }

      function f(e, t, r) {
        for (var n = "", i = t; i < t + r; i++) {
          n += String.fromCharCode(e.getUint8(i));
        }

        return n;
      }

      function l(e, t) {
        if ("Exif" != f(e, t, 4)) return p && console.log("Not valid EXIF data! " + f(e, t, 4)), !1;
        var r,
            n,
            i,
            o,
            a,
            u = t + 6;
        if (18761 == e.getUint16(u)) r = !1;else {
          if (19789 != e.getUint16(u)) return p && console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"), !1;
          r = !0;
        }
        if (42 != e.getUint16(u + 2, !r)) return p && console.log("Not valid TIFF data! (no 0x002A)"), !1;
        var c = e.getUint32(u + 4, !r);
        if (c < 8) return p && console.log("Not valid TIFF data! (First offset less than 8)", e.getUint32(u + 4, !r)), !1;
        if ((n = s(e, u, u + c, v, r)).ExifIFDPointer) for (i in o = s(e, u, u + n.ExifIFDPointer, h, r)) {
          switch (i) {
            case "LightSource":
            case "Flash":
            case "MeteringMode":
            case "ExposureProgram":
            case "SensingMethod":
            case "SceneCaptureType":
            case "SceneType":
            case "CustomRendered":
            case "WhiteBalance":
            case "GainControl":
            case "Contrast":
            case "Saturation":
            case "Sharpness":
            case "SubjectDistanceRange":
            case "FileSource":
              o[i] = y[i][o[i]];
              break;

            case "ExifVersion":
            case "FlashpixVersion":
              o[i] = String.fromCharCode(o[i][0], o[i][1], o[i][2], o[i][3]);
              break;

            case "ComponentsConfiguration":
              o[i] = y.Components[o[i][0]] + y.Components[o[i][1]] + y.Components[o[i][2]] + y.Components[o[i][3]];
          }

          n[i] = o[i];
        }
        if (n.GPSInfoIFDPointer) for (i in a = s(e, u, u + n.GPSInfoIFDPointer, g, r)) {
          switch (i) {
            case "GPSVersionID":
              a[i] = a[i][0] + "." + a[i][1] + "." + a[i][2] + "." + a[i][3];
          }

          n[i] = a[i];
        }
        return n.thumbnail = function (e, t, r, n) {
          var i = function (e, t, r) {
            var n = e.getUint16(t, !r);
            return e.getUint32(t + 2 + 12 * n, !r);
          }(e, t + r, n);

          if (!i) return {};
          if (i > e.byteLength) return {};
          var o = s(e, t, t + i, m, n);
          if (o.Compression) switch (o.Compression) {
            case 6:
              if (o.JpegIFOffset && o.JpegIFByteCount) {
                var a = t + o.JpegIFOffset,
                    u = o.JpegIFByteCount;
                o.blob = new Blob([new Uint8Array(e.buffer, a, u)], {
                  type: "image/jpeg"
                });
              }

              break;

            case 1:
              console.log("Thumbnail image format is TIFF, which is not implemented.");
              break;

            default:
              console.log("Unknown thumbnail image format '%s'", o.Compression);
          } else 2 == o.PhotometricInterpretation && console.log("Thumbnail image format is RGB, which is not implemented.");
          return o;
        }(e, u, c, r), n;
      }

      var p = !1,
          d = function e(t) {
        return t instanceof e ? t : this instanceof e ? void (this.EXIFwrapped = t) : new e(t);
      };

      void 0 !== e && e.exports && (t = e.exports = d), t.EXIF = d;
      var h = d.Tags = {
        36864: "ExifVersion",
        40960: "FlashpixVersion",
        40961: "ColorSpace",
        40962: "PixelXDimension",
        40963: "PixelYDimension",
        37121: "ComponentsConfiguration",
        37122: "CompressedBitsPerPixel",
        37500: "MakerNote",
        37510: "UserComment",
        40964: "RelatedSoundFile",
        36867: "DateTimeOriginal",
        36868: "DateTimeDigitized",
        37520: "SubsecTime",
        37521: "SubsecTimeOriginal",
        37522: "SubsecTimeDigitized",
        33434: "ExposureTime",
        33437: "FNumber",
        34850: "ExposureProgram",
        34852: "SpectralSensitivity",
        34855: "ISOSpeedRatings",
        34856: "OECF",
        37377: "ShutterSpeedValue",
        37378: "ApertureValue",
        37379: "BrightnessValue",
        37380: "ExposureBias",
        37381: "MaxApertureValue",
        37382: "SubjectDistance",
        37383: "MeteringMode",
        37384: "LightSource",
        37385: "Flash",
        37396: "SubjectArea",
        37386: "FocalLength",
        41483: "FlashEnergy",
        41484: "SpatialFrequencyResponse",
        41486: "FocalPlaneXResolution",
        41487: "FocalPlaneYResolution",
        41488: "FocalPlaneResolutionUnit",
        41492: "SubjectLocation",
        41493: "ExposureIndex",
        41495: "SensingMethod",
        41728: "FileSource",
        41729: "SceneType",
        41730: "CFAPattern",
        41985: "CustomRendered",
        41986: "ExposureMode",
        41987: "WhiteBalance",
        41988: "DigitalZoomRation",
        41989: "FocalLengthIn35mmFilm",
        41990: "SceneCaptureType",
        41991: "GainControl",
        41992: "Contrast",
        41993: "Saturation",
        41994: "Sharpness",
        41995: "DeviceSettingDescription",
        41996: "SubjectDistanceRange",
        40965: "InteroperabilityIFDPointer",
        42016: "ImageUniqueID"
      },
          v = d.TiffTags = {
        256: "ImageWidth",
        257: "ImageHeight",
        34665: "ExifIFDPointer",
        34853: "GPSInfoIFDPointer",
        40965: "InteroperabilityIFDPointer",
        258: "BitsPerSample",
        259: "Compression",
        262: "PhotometricInterpretation",
        274: "Orientation",
        277: "SamplesPerPixel",
        284: "PlanarConfiguration",
        530: "YCbCrSubSampling",
        531: "YCbCrPositioning",
        282: "XResolution",
        283: "YResolution",
        296: "ResolutionUnit",
        273: "StripOffsets",
        278: "RowsPerStrip",
        279: "StripByteCounts",
        513: "JPEGInterchangeFormat",
        514: "JPEGInterchangeFormatLength",
        301: "TransferFunction",
        318: "WhitePoint",
        319: "PrimaryChromaticities",
        529: "YCbCrCoefficients",
        532: "ReferenceBlackWhite",
        306: "DateTime",
        270: "ImageDescription",
        271: "Make",
        272: "Model",
        305: "Software",
        315: "Artist",
        33432: "Copyright"
      },
          g = d.GPSTags = {
        0: "GPSVersionID",
        1: "GPSLatitudeRef",
        2: "GPSLatitude",
        3: "GPSLongitudeRef",
        4: "GPSLongitude",
        5: "GPSAltitudeRef",
        6: "GPSAltitude",
        7: "GPSTimeStamp",
        8: "GPSSatellites",
        9: "GPSStatus",
        10: "GPSMeasureMode",
        11: "GPSDOP",
        12: "GPSSpeedRef",
        13: "GPSSpeed",
        14: "GPSTrackRef",
        15: "GPSTrack",
        16: "GPSImgDirectionRef",
        17: "GPSImgDirection",
        18: "GPSMapDatum",
        19: "GPSDestLatitudeRef",
        20: "GPSDestLatitude",
        21: "GPSDestLongitudeRef",
        22: "GPSDestLongitude",
        23: "GPSDestBearingRef",
        24: "GPSDestBearing",
        25: "GPSDestDistanceRef",
        26: "GPSDestDistance",
        27: "GPSProcessingMethod",
        28: "GPSAreaInformation",
        29: "GPSDateStamp",
        30: "GPSDifferential"
      },
          m = d.IFD1Tags = {
        256: "ImageWidth",
        257: "ImageHeight",
        258: "BitsPerSample",
        259: "Compression",
        262: "PhotometricInterpretation",
        273: "StripOffsets",
        274: "Orientation",
        277: "SamplesPerPixel",
        278: "RowsPerStrip",
        279: "StripByteCounts",
        282: "XResolution",
        283: "YResolution",
        284: "PlanarConfiguration",
        296: "ResolutionUnit",
        513: "JpegIFOffset",
        514: "JpegIFByteCount",
        529: "YCbCrCoefficients",
        530: "YCbCrSubSampling",
        531: "YCbCrPositioning",
        532: "ReferenceBlackWhite"
      },
          y = d.StringValues = {
        ExposureProgram: {
          0: "Not defined",
          1: "Manual",
          2: "Normal program",
          3: "Aperture priority",
          4: "Shutter priority",
          5: "Creative program",
          6: "Action program",
          7: "Portrait mode",
          8: "Landscape mode"
        },
        MeteringMode: {
          0: "Unknown",
          1: "Average",
          2: "CenterWeightedAverage",
          3: "Spot",
          4: "MultiSpot",
          5: "Pattern",
          6: "Partial",
          255: "Other"
        },
        LightSource: {
          0: "Unknown",
          1: "Daylight",
          2: "Fluorescent",
          3: "Tungsten (incandescent light)",
          4: "Flash",
          9: "Fine weather",
          10: "Cloudy weather",
          11: "Shade",
          12: "Daylight fluorescent (D 5700 - 7100K)",
          13: "Day white fluorescent (N 4600 - 5400K)",
          14: "Cool white fluorescent (W 3900 - 4500K)",
          15: "White fluorescent (WW 3200 - 3700K)",
          17: "Standard light A",
          18: "Standard light B",
          19: "Standard light C",
          20: "D55",
          21: "D65",
          22: "D75",
          23: "D50",
          24: "ISO studio tungsten",
          255: "Other"
        },
        Flash: {
          0: "Flash did not fire",
          1: "Flash fired",
          5: "Strobe return light not detected",
          7: "Strobe return light detected",
          9: "Flash fired, compulsory flash mode",
          13: "Flash fired, compulsory flash mode, return light not detected",
          15: "Flash fired, compulsory flash mode, return light detected",
          16: "Flash did not fire, compulsory flash mode",
          24: "Flash did not fire, auto mode",
          25: "Flash fired, auto mode",
          29: "Flash fired, auto mode, return light not detected",
          31: "Flash fired, auto mode, return light detected",
          32: "No flash function",
          65: "Flash fired, red-eye reduction mode",
          69: "Flash fired, red-eye reduction mode, return light not detected",
          71: "Flash fired, red-eye reduction mode, return light detected",
          73: "Flash fired, compulsory flash mode, red-eye reduction mode",
          77: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
          79: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
          89: "Flash fired, auto mode, red-eye reduction mode",
          93: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
          95: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
          1: "Not defined",
          2: "One-chip color area sensor",
          3: "Two-chip color area sensor",
          4: "Three-chip color area sensor",
          5: "Color sequential area sensor",
          7: "Trilinear sensor",
          8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
          0: "Standard",
          1: "Landscape",
          2: "Portrait",
          3: "Night scene"
        },
        SceneType: {
          1: "Directly photographed"
        },
        CustomRendered: {
          0: "Normal process",
          1: "Custom process"
        },
        WhiteBalance: {
          0: "Auto white balance",
          1: "Manual white balance"
        },
        GainControl: {
          0: "None",
          1: "Low gain up",
          2: "High gain up",
          3: "Low gain down",
          4: "High gain down"
        },
        Contrast: {
          0: "Normal",
          1: "Soft",
          2: "Hard"
        },
        Saturation: {
          0: "Normal",
          1: "Low saturation",
          2: "High saturation"
        },
        Sharpness: {
          0: "Normal",
          1: "Soft",
          2: "Hard"
        },
        SubjectDistanceRange: {
          0: "Unknown",
          1: "Macro",
          2: "Close view",
          3: "Distant view"
        },
        FileSource: {
          3: "DSC"
        },
        Components: {
          0: "",
          1: "Y",
          2: "Cb",
          3: "Cr",
          4: "R",
          5: "G",
          6: "B"
        }
      },
          b = {
        120: "caption",
        110: "credit",
        25: "keywords",
        55: "dateCreated",
        80: "byline",
        85: "bylineTitle",
        122: "captionWriter",
        105: "headline",
        116: "copyright",
        15: "category"
      };
      d.getData = function (e, t) {
        return !((self.Image && e instanceof self.Image || self.HTMLImageElement && e instanceof self.HTMLImageElement) && !e.complete) && (r(e) ? t && t.call(e) : o(e, t), !0);
      }, d.getTag = function (e, t) {
        if (r(e)) return e.exifdata[t];
      }, d.getIptcTag = function (e, t) {
        if (r(e)) return e.iptcdata[t];
      }, d.getAllTags = function (e) {
        if (!r(e)) return {};
        var t,
            n = e.exifdata,
            i = {};

        for (t in n) {
          n.hasOwnProperty(t) && (i[t] = n[t]);
        }

        return i;
      }, d.getAllIptcTags = function (e) {
        if (!r(e)) return {};
        var t,
            n = e.iptcdata,
            i = {};

        for (t in n) {
          n.hasOwnProperty(t) && (i[t] = n[t]);
        }

        return i;
      }, d.pretty = function (e) {
        if (!r(e)) return "";
        var t,
            n = e.exifdata,
            o = "";

        for (t in n) {
          n.hasOwnProperty(t) && ("object" == i(n[t]) ? n[t] instanceof Number ? o += t + " : " + n[t] + " [" + n[t].numerator + "/" + n[t].denominator + "]\r\n" : o += t + " : [" + n[t].length + " values]\r\n" : o += t + " : " + n[t] + "\r\n");
        }

        return o;
      }, d.readFromBinaryFile = function (e) {
        return a(e);
      }, void 0 === (n = function () {
        return d;
      }.apply(t, [])) || (e.exports = n);
    }).call(void 0);
  }, function (e, t, r) {
    "use strict";

    "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
      value: function value(e, t) {
        if (null == e) throw new TypeError("Cannot convert undefined or null to object");

        for (var r = Object(e), n = 1; n < arguments.length; n++) {
          var i = arguments[n];
          if (null != i) for (var o in i) {
            Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
          }
        }

        return r;
      },
      writable: !0,
      configurable: !0
    });
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
      console.warn('[FLAMELINK] The "' + e + '" method is deprecated and will be removed in the next major version. ' + t);
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function i(e) {
      return function () {
        var t = e.apply(this, arguments);
        return new Promise(function (e, r) {
          return function n(i, o) {
            try {
              var a = t[i](o),
                  u = a.value;
            } catch (e) {
              return void r(e);
            }

            if (!a.done) return Promise.resolve(u).then(function (e) {
              n("next", e);
            }, function (e) {
              n("throw", e);
            });
            e(u);
          }("next");
        });
      };
    }

    function o(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.prepConstraintsForValidate = t.hasNonCacheableOptions = t.getScreenResolution = t.formatStructure = t.populateEntry = t.prepPopulateFields = t.pluckResultFields = t.filterByFolderId = t.getMediaRefPath = t.getFolderRefPath = t.getFileRefPath = t.getStorageRefPath = t.getSettingsRefPath = t.getSchemasRefPath = t.getNavigationRefPath = t.getContentRefPath = t.applyFilters = t.applyOrderBy = t.AVAILABLE_FILTER_OPTIONS = void 0;

    var a,
        u,
        s = function () {
      return function (e, t) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return function (e, t) {
          var r = [],
              n = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              !n && u.return && u.return();
            } finally {
              if (i) throw o;
            }
          }

          return r;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      };
    }(),
        c = n(r(3)),
        f = n(r(233)),
        l = n(r(96)),
        p = n(r(241)),
        d = n(r(0)),
        h = n(r(71)),
        v = n(r(97)),
        g = n(r(78)),
        m = n(r(53)),
        y = n(r(99)),
        b = {},
        x = t.AVAILABLE_FILTER_OPTIONS = ["limitToFirst", "limitToLast", "startAt", "endAt", "equalTo"],
        w = (t.applyOrderBy = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

      if (t.orderByChild) {
        if ("string" != typeof t.orderByChild || "" === t.orderByChild) throw (0, y.default)('"orderByChild" should specify the child key to order by');
        return e.orderByChild(t.orderByChild);
      }

      return t.orderByValue ? e.orderByValue() : t.orderByKey ? e.orderByKey() : e;
    }, t.applyFilters = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (0, c.default)(t).length ? [].concat(x).reduce(function (e, r) {
        return void 0 === t[r] ? e : e[r](t[r]);
      }, e) : e;
    }, function () {
      throw (0, y.default)("The reference, environment and locale arguments are all required");
    }),
        R = (t.getContentRefPath = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : w(),
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : w(),
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w();
      return (0, d.default)(e) ? "/flamelink/environments/" + t + "/content/" + (e[0] ? e[0] + "/" + r + (e[1] ? "/" + e[1] : "") : "") : "/flamelink/environments/" + t + "/content/" + (e ? e + "/" + r : "");
    }, t.getNavigationRefPath = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : w(),
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : w(),
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : w();
      return "/flamelink/environments/" + t + "/navigation/" + (e ? e + "/" + r : "");
    }, t.getSchemasRefPath = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : w();
      return "/flamelink/environments/" + (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : w()) + "/schemas/" + (e || "");
    }, t.getSettingsRefPath = function (e) {
      return "/flamelink/settings/" + (e || "");
    }, t.getStorageRefPath = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : w(),
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.width,
          n = t.path;
      return n ? "/flamelink/media/sized/" + n + "/" + e : "/flamelink/media/" + (r ? "sized/" + r + "/" : "") + e;
    }, t.getFileRefPath = function (e) {
      return "/flamelink/media/files/" + (e || "");
    }, t.getFolderRefPath = function (e) {
      return "/flamelink/media/folders/" + (e || "");
    }, t.getMediaRefPath = function (e) {
      return "/flamelink/media/" + (e || "");
    }, t.filterByFolderId = (0, l.default)(function (e, t) {
      return e ? (0, f.default)(t, function (t, r, n) {
        return r.folderId === e ? Object.assign({}, t, o({}, n, r)) : t;
      }, {}) : t;
    }), t.pluckResultFields = (0, l.default)(function (e, t) {
      if (!t || !(0, d.default)(e)) return t;
      var r = (0, g.default)(e);
      return (0, d.default)(t) ? (0, f.default)(t, function (e, t) {
        return e.concat(r(t));
      }, []) : (0, v.default)(t) ? (0, f.default)(t, function (e, t, n) {
        return Object.assign({}, e, o({}, n, r(t)));
      }, {}) : t;
    })),
        _ = t.prepPopulateFields = function (e) {
      return void 0 === b.prepPopulateFields && (b.prepPopulateFields = (0, h.default)(function (e) {
        return e && (0, d.default)(e) ? e.map(function (e) {
          return "string" == typeof e ? {
            field: e
          } : e;
        }) : [];
      }, function (e) {
        return JSON.stringify(e);
      })), b.prepPopulateFields(e);
    },
        j = (a = i(_regeneratorRuntime.mark(function e(t, r) {
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", r.reduce(function () {
                var e = i(_regeneratorRuntime.mark(function e(r, n) {
                  return _regeneratorRuntime.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          e.t0 = n.type, e.next = "media" === e.t0 ? 3 : "select-relational" === e.t0 ? 4 : "tree-relational" === e.t0 ? 4 : "fieldset" === e.t0 ? 5 : "repeater" === e.t0 ? 5 : 6;
                          break;

                        case 3:
                          return e.abrupt("return", r.then(function (e) {
                            return e.concat({
                              field: n.key
                            });
                          }));

                        case 4:
                          return e.abrupt("return", r.then(function () {
                            var e = i(_regeneratorRuntime.mark(function e(r) {
                              return _regeneratorRuntime.wrap(function (e) {
                                for (;;) {
                                  switch (e.prev = e.next) {
                                    case 0:
                                      return e.t0 = r, e.t1 = n.key, e.t2 = j, e.t3 = t, e.next = 6, t.getFields(n.relation);

                                    case 6:
                                      return e.t4 = e.sent, e.next = 9, (0, e.t2)(e.t3, e.t4);

                                    case 9:
                                      return e.t5 = e.sent, e.t6 = {
                                        field: e.t1,
                                        populate: e.t5
                                      }, e.abrupt("return", e.t0.concat.call(e.t0, e.t6));

                                    case 12:
                                    case "end":
                                      return e.stop();
                                  }
                                }
                              }, e, void 0);
                            }));
                            return function (t) {
                              return e.apply(this, arguments);
                            };
                          }()));

                        case 5:
                          return e.abrupt("return", r.then(function () {
                            var e = i(_regeneratorRuntime.mark(function e(r) {
                              return _regeneratorRuntime.wrap(function (e) {
                                for (;;) {
                                  switch (e.prev = e.next) {
                                    case 0:
                                      return e.t0 = r, e.t1 = n.key, e.next = 4, j(t, n.options);

                                    case 4:
                                      return e.t2 = e.sent, e.t3 = {
                                        field: e.t1,
                                        subFields: e.t2
                                      }, e.abrupt("return", e.t0.concat.call(e.t0, e.t3));

                                    case 7:
                                    case "end":
                                      return e.stop();
                                  }
                                }
                              }, e, void 0);
                            }));
                            return function (t) {
                              return e.apply(this, arguments);
                            };
                          }()));

                        case 6:
                          return e.abrupt("return", r);

                        case 7:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e, void 0);
                }));
                return function (t, r) {
                  return e.apply(this, arguments);
                };
              }(), Promise.resolve([])));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, void 0);
    })), function (e, t) {
      return a.apply(this, arguments);
    }),
        O = t.populateEntry = (0, l.default)((u = i(_regeneratorRuntime.mark(function e(t, r, n, a, u, f) {
      var h, g, b, x, w;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (f) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", f);

            case 2:
              if (0 !== (h = (0, c.default)(f)).length) {
                e.next = 5;
                break;
              }

              throw (0, y.default)('"populateEntry" should be called with an object of objects');

            case 5:
              return g = (0, l.default)(function () {
                var e = i(_regeneratorRuntime.mark(function e(a, u, f, l) {
                  var h, b;
                  return _regeneratorRuntime.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (f[0]) {
                            e.next = 2;
                            break;
                          }

                          return e.abrupt("return", a);

                        case 2:
                          if ((h = f.reduce(function (e, t) {
                            var r = u && u.find(function (e) {
                              return e.key === t.field;
                            });
                            return r && r.relation ? e.concat([Object.assign({}, t, {
                              contentType: r.relation,
                              populateType: "relational"
                            })]) : r && "media" === r.type ? e.concat([Object.assign({}, t, {
                              populateType: "media"
                            })]) : r && "repeater" === r.type && (0, d.default)(t.subFields) ? e.concat([Object.assign({}, t, {
                              populateType: "repeater"
                            })]) : r && "fieldset" === r.type && (0, d.default)(t.subFields) ? e.concat([Object.assign({}, t, {
                              populateType: "fieldset"
                            })]) : e;
                          }, []))[0]) {
                            e.next = 5;
                            break;
                          }

                          return e.abrupt("return", a);

                        case 5:
                          return e.next = 7, Promise.all(h.map(function () {
                            var e = i(_regeneratorRuntime.mark(function e(f) {
                              var p, h, b, x, w, j, S, k, F, P, A;
                              return _regeneratorRuntime.wrap(function (e) {
                                for (;;) {
                                  switch (e.prev = e.next) {
                                    case 0:
                                      p = f.field, h = f.subFields, b = f.contentType, x = f.populateType, e.t0 = x, e.next = "media" === e.t0 ? 4 : "relational" === e.t0 ? 10 : "repeater" === e.t0 ? 15 : "fieldset" === e.t0 ? 22 : 32;
                                      break;

                                    case 4:
                                      if (!a[l] || !a[l].hasOwnProperty(p)) {
                                        e.next = 9;
                                        break;
                                      }

                                      if (w = a[l][p] || [], (0, d.default)(w)) {
                                        e.next = 8;
                                        break;
                                      }

                                      throw (0, y.default)('The "' + p + '" field does not seem to be a valid media property.');

                                    case 8:
                                      return e.abrupt("return", Promise.all(w.map(function () {
                                        var e = i(_regeneratorRuntime.mark(function e(i) {
                                          var a, u, c, l, p, d, h, v;
                                          return _regeneratorRuntime.wrap(function (e) {
                                            for (;;) {
                                              switch (e.prev = e.next) {
                                                case 0:
                                                  return a = R(f.fields), u = O(t, r, n, b, f.populate), e.next = 4, Promise.all([n.getFile(i, f), n.getURL(i, f)]);

                                                case 4:
                                                  return c = e.sent, l = s(c, 2), p = l[0], d = l[1], h = o({}, i, Object.assign({}, p, {
                                                    url: d
                                                  })), e.next = 11, (0, m.default)(u, a)(h);

                                                case 11:
                                                  return v = e.sent, e.abrupt("return", v[i]);

                                                case 13:
                                                case "end":
                                                  return e.stop();
                                              }
                                            }
                                          }, e, void 0);
                                        }));
                                        return function (t) {
                                          return e.apply(this, arguments);
                                        };
                                      }())));

                                    case 9:
                                      return e.abrupt("return", null);

                                    case 10:
                                      if (!a[l] || !a[l].hasOwnProperty(p)) {
                                        e.next = 14;
                                        break;
                                      }

                                      return j = a[l][p], j = (0, d.default)(j) ? j : [j], e.abrupt("return", Promise.all(j.map(function () {
                                        var e = i(_regeneratorRuntime.mark(function e(i) {
                                          var a, u, s, c, l;
                                          return _regeneratorRuntime.wrap(function (e) {
                                            for (;;) {
                                              switch (e.prev = e.next) {
                                                case 0:
                                                  return a = R(f.fields), u = O(t, r, n, b, f.populate), e.next = 4, r.getRaw(b, i, f);

                                                case 4:
                                                  return s = e.sent, c = o({}, i, s.val()), e.next = 8, (0, m.default)(u, a)(c);

                                                case 8:
                                                  return l = e.sent, e.abrupt("return", l[i]);

                                                case 10:
                                                case "end":
                                                  return e.stop();
                                              }
                                            }
                                          }, e, void 0);
                                        }));
                                        return function (t) {
                                          return e.apply(this, arguments);
                                        };
                                      }())));

                                    case 14:
                                      return e.abrupt("return", null);

                                    case 15:
                                      if (!a[l] || !a[l].hasOwnProperty(p)) {
                                        e.next = 21;
                                        break;
                                      }

                                      if (S = a[l][p] || [], (0, d.default)(S)) {
                                        e.next = 19;
                                        break;
                                      }

                                      throw (0, y.default)('The "' + p + '" field does not seem to be a valid repeater field.');

                                    case 19:
                                      return k = u && u.find(function (e) {
                                        return e.key === p;
                                      }), e.abrupt("return", Promise.all(S.map(function () {
                                        var e = i(_regeneratorRuntime.mark(function e(t, r) {
                                          var n;
                                          return _regeneratorRuntime.wrap(function (e) {
                                            for (;;) {
                                              switch (e.prev = e.next) {
                                                case 0:
                                                  return e.next = 2, g(o({}, r, t), k.options || [], _(h), r);

                                                case 2:
                                                  return n = e.sent, e.abrupt("return", n[r]);

                                                case 4:
                                                case "end":
                                                  return e.stop();
                                              }
                                            }
                                          }, e, void 0);
                                        }));
                                        return function (t, r) {
                                          return e.apply(this, arguments);
                                        };
                                      }())));

                                    case 21:
                                      return e.abrupt("return", null);

                                    case 22:
                                      if (!a[l] || !a[l].hasOwnProperty(p)) {
                                        e.next = 31;
                                        break;
                                      }

                                      if (F = a[l][p], (0, v.default)(F)) {
                                        e.next = 26;
                                        break;
                                      }

                                      throw (0, y.default)('The "' + p + '" field does not seem to be a valid fieldset field.');

                                    case 26:
                                      return P = u && u.find(function (e) {
                                        return e.key === p;
                                      }), e.next = 29, Promise.all((0, c.default)(F).map(function () {
                                        var e = i(_regeneratorRuntime.mark(function e(t, r) {
                                          var n;
                                          return _regeneratorRuntime.wrap(function (e) {
                                            for (;;) {
                                              switch (e.prev = e.next) {
                                                case 0:
                                                  return e.next = 2, g(o({}, r, o({}, t, F[t])), P.options || [], _(h), r);

                                                case 2:
                                                  return n = e.sent, e.abrupt("return", n[r]);

                                                case 4:
                                                case "end":
                                                  return e.stop();
                                              }
                                            }
                                          }, e, void 0);
                                        }));
                                        return function (t, r) {
                                          return e.apply(this, arguments);
                                        };
                                      }()));

                                    case 29:
                                      return A = e.sent, e.abrupt("return", A.reduce(function (e, t) {
                                        return Object.assign({}, e, t);
                                      }, {}));

                                    case 31:
                                      return e.abrupt("return", null);

                                    case 32:
                                      return e.abrupt("return", a[l][p]);

                                    case 33:
                                    case "end":
                                      return e.stop();
                                  }
                                }
                              }, e, void 0);
                            }));
                            return function (t) {
                              return e.apply(this, arguments);
                            };
                          }()));

                        case 7:
                          return b = e.sent, e.abrupt("return", h.reduce(function (e, t, r) {
                            var n = t.field;
                            return e[l] && e[l].hasOwnProperty(n) && (e[l][n] = b[r]), e;
                          }, (0, p.default)(a)));

                        case 9:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e, void 0);
                }));
                return function (t, r, n, i) {
                  return e.apply(this, arguments);
                };
              }()), e.next = 8, t.getFields(a);

            case 8:
              if (b = e.sent, !0 !== u) {
                e.next = 13;
                break;
              }

              return e.next = 12, j(t, b);

            case 12:
              u = e.sent;

            case 13:
              return x = _(u), e.next = 16, Promise.all(h.map(g(f, b, x)));

            case 16:
              return w = e.sent, e.abrupt("return", h.reduce(function (e, t, r) {
                return Object.assign({}, e, o({}, t, w[r][t]));
              }, {}));

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, void 0);
    })), function (e, t, r, n, i, o) {
      return u.apply(this, arguments);
    }));

    t.formatStructure = (0, l.default)(function (e, t, r) {
      var n = t || {},
          i = n.idProperty,
          o = void 0 === i ? "id" : i,
          a = n.parentProperty,
          u = void 0 === a ? "parentId" : a,
          s = (0, d.default)(r) ? r : (0, c.default)(r).map(function (e) {
        return r[e];
      });
      if (!(0, d.default)(s)) throw (0, y.default)('"formatStructure" should be called with an array of items');

      if ("nested" === e || "tree" === e) {
        return function e(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          return t.map(function (e) {
            return Object.assign({}, e, {
              children: s.filter(function (t) {
                return t[u] === e[o];
              })
            });
          }).filter(function (e) {
            return e[u] === r;
          }).map(function (t) {
            return 0 === t.children.length ? t : Object.assign({}, t, {
              children: e(t.children, t[o])
            });
          });
        }(s, 0);
      }

      return s;
    }), t.getScreenResolution = function () {
      var e = "devicePixelRatio" in window ? window.devicePixelRatio : 1;
      return Math.max(window.screen.width, window.screen.height) * e;
    }, t.hasNonCacheableOptions = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return (0, c.default)(e).some(function (e) {
        return ["noCache", "event", "orderByValue", "orderByChild"].concat(x).includes(e);
      });
    }, t.prepConstraintsForValidate = function (e) {
      return (0, d.default)(e) ? e.reduce(function (e, t) {
        return Object.assign({}, e, o({}, t.rule, t.ruleValue));
      }, {}) : (0, v.default)(e) ? e : {};
    };
  }, function (e, t, r) {
    var n = r(234),
        i = r(235),
        o = r(14),
        a = r(240),
        u = r(0);

    e.exports = function (e, t, r) {
      var s = u(e) ? n : a,
          c = arguments.length < 3;
      return s(e, o(t, 4), r, c, i);
    };
  }, function (e, t) {
    e.exports = function (e, t, r, n) {
      var i = -1,
          o = null == e ? 0 : e.length;

      for (n && o && (r = e[++i]); ++i < o;) {
        r = t(r, e[i], i, e);
      }

      return r;
    };
  }, function (e, t, r) {
    var n = r(236),
        i = r(239)(n);
    e.exports = i;
  }, function (e, t, r) {
    var n = r(237),
        i = r(3);

    e.exports = function (e, t) {
      return e && n(e, t, i);
    };
  }, function (e, t, r) {
    var n = r(238)();
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      return function (t, r, n) {
        for (var i = -1, o = Object(t), a = n(t), u = a.length; u--;) {
          var s = a[e ? u : ++i];
          if (!1 === r(o[s], s, o)) break;
        }

        return t;
      };
    };
  }, function (e, t, r) {
    var n = r(13);

    e.exports = function (e, t) {
      return function (r, i) {
        if (null == r) return r;
        if (!n(r)) return e(r, i);

        for (var o = r.length, a = t ? o : -1, u = Object(r); (t ? a-- : ++a < o) && !1 !== i(u[a], a, u);) {
          ;
        }

        return r;
      };
    };
  }, function (e, t) {
    e.exports = function (e, t, r, n, i) {
      return i(e, function (e, i, o) {
        r = n ? (n = !1, e) : t(r, e, i, o);
      }), r;
    };
  }, function (e, t, r) {
    var n = r(49),
        i = 1,
        o = 4;

    e.exports = function (e) {
      return n(e, i | o);
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.DEFAULT_CONFIG = {
      env: "production",
      locale: "en-US"
    }, t.ALLOWED_CHILD_EVENTS = ["value", "child_added", "child_removed", "child_changed", "child_moved"], t.DEFAULT_REQUIRED_IMAGE_SIZE = 240;
  }]);
});